<template>
  <div>
    
    <v-dialog width="400" v-model="RAPresetDialog">
    <v-card>
        <v-card-title>
            Preset Config
        </v-card-title>
        <v-card-text>
            <v-text-field v-model="RAPresetTab.Preset_Name" label="Preset Name"
            />
            <v-textarea v-model="RAPresetTab.Preset_Description" label="Description"
            />
            <v-select v-model="RAPresetTab.Category" label="Category" :items="ContentBlockClasses"
            />
            <v-select v-if="RAAdmin" v-model="RAPresetTab.Database" label="Database" :items="['Client','RA Presets']"
            />
             
        </v-card-text>
        <v-card-actions>
            <v-btn dark color="warning" @click="CancelRAPresetDialog()">
                Cancel
            </v-btn>
            <v-spacer>
            </v-spacer>
            <v-btn dark color="success" @click="SaveRAPreset()"
            >Save</v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog v-model="BulkContentBlocktoPresetDialog" width="400">
        <v-card
    class="mx-auto"
    max-width="500"
  >
    <v-card-title class="text-h6 font-weight-regular justify-space-between">
      <span>{{ currentTitle }}</span>
      <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="BulkContentPresetStep"
      ></v-avatar>
    </v-card-title>

    <v-window v-model="BulkContentPresetStep">
        <v-window-item :value="1">
        <v-card-text>
          <v-progress-circular
            indeterminate
            color="primary"
            ></v-progress-circular>
        </v-card-text>
        
      </v-window-item>
      <v-window-item :value="2">
        <v-card-text>
           <v-text-field v-model="RAPresetTab.Preset_Name" label="Preset Name"
            />
            <v-textarea v-model="RAPresetTab.Preset_Description" label="Description"
            />
            <v-select v-model="RAPresetTab.Category" label="Category" :items="ContentBlockClasses"
            />
        </v-card-text>        
      </v-window-item>
       <v-card-actions>
            <v-btn dark color="warning" @click="CancelRAPresetDialog()">
                Cancel
            </v-btn>
            <v-spacer>
            </v-spacer>
            <v-btn dark color="success" @click="AdvanceContentBlocktoPresetDial()"
            >Save</v-btn>
        </v-card-actions>
    </v-window>
        </v-card>
    </v-dialog>
      <v-dialog max-width="350" v-model="SEOBasicsDialog">
        <v-card tile flat width="100%">
            <v-card-title>
            </v-card-title>
            <v-card-text>
                <v-switch label="Page Shows on Web Searches" v-model="SEOPage.SEO"
                />
                <ContentEditableField style="padding:15px;"
                :FieldObject="SEOPage" :FieldName="'Overview'"
                :FieldValue="SEOPage.Overview" @UpdateContentEditableField="UpdateContentEditableField" :AdditionalSaveMethod="''" />
                <v-combobox
                        v-model="SEOPage.KeyWords"
                        :items="KeyWords"
                        label="KeyWords"
                        multiple
                        chips
                        >
                </v-combobox>
            </v-card-text>
            <v-card-text  v-if="SEOPage.SEO">
                Web Preview
                <v-list-item style="width:100%;padding-top:10px;padding-left:20px;border: 1px solid #ccc !important;" three-line> 
                                       
                    <v-list-item-content>
                        <v-list-item-title class="caption" style="margin-bottom:-6px;">{{DefaultPath+SEOPage.PageRoute}}</v-list-item-title>
                        <v-list-item-subtitle class="text-h7">
                        <v-btn  class="underlinehover" style="padding-left:0px;text-transform: capitalize;font-size: 0.925em;color: #1a0dab!important;" text plain depressed>
                            <span>{{System.Name}} || </span>
                        <span v-if="ActiveGroup && IsGroupView">{{ActiveGroup.name}} || </span> {{SEOPage.Name}} <v-icon color="#1a0dab" small dark>{{SEOPage.PageIcon}}</v-icon></v-btn>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle style="display: block;" v-html="SEOPage.Overview">
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="DeactivateSEODialog()" dark color="warning">
                    Cancel</v-btn>
                    <v-spacer>
                    </v-spacer>
                    <v-btn  @click="UpdateSEOBasics()"  dark color="success">
                        Save
                    </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-navigation-drawer :app="!MiniView" hide-overlay
                    mini-variant v-model="SiteDialog" v-if="!PublicNavbarEditing"
                    :permanent="!MiniView || MiniView && SiteDialog" mini-variant-width="100"
                    :style="!$route.meta.DataSingleBuilder|| $route.name === 'SystemConfig'? 'z-index:8;height: 100%;top:65px;position: fixed;'
                    : 'z-index:2;height: 100%;top:60px;position: fixed;'"
                   >	
                    <v-list-item class="px-2">
                    <v-list-item-avatar>
                    <v-img :src="ActiveGroup && ActiveGroup.logo ? ActiveGroup.logo : require('@/assets/logo.png')"></v-img>
                    </v-list-item-avatar>
                </v-list-item>
                <v-divider></v-divider>
                <v-list dense>
                     <v-list-item
                    v-for="main in FilteredTopItems"
                    :key="main.itemObjKey"
                    link
                    >
                     <v-btn @click="ActivateSelectedMain(main)">
                        <v-icon>{{main.icon}}</v-icon>
                            <v-badge color="warning" v-if="main.notifications" left>
                        <span slot="badge"> {{main.notifications}}</span>
                        </v-badge>
                    </v-btn>
                    </v-list-item>
                    <v-list-item>
                            <v-tooltip bottom max-width="200">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-progress-circular v-on="on" v-bind="attrs"
                                    :rotate="360" @click="ActivateProgressSheet()"
                                    :size="80"
                                    :width="15"
                                    :indeterminate="!ComputedProgressItem" 
                                    :value="progressvalue"
                                    color="links"
                                    >
                                    {{ComputedProgressItem ? ComputedProgressItem.StepsCompleted+'/'+ComputedProgressItem.Steps : ''}}
                                    </v-progress-circular>
                                </template>
                                <span v-html="ComputedProgressItem ? ComputedProgressItem.Toolip : 'Select an item'">
                                </span>
                            </v-tooltip>
                    </v-list-item>
                    <v-list-item
                    v-for="main in Computedsitenavitems"
                    :key="main.itemObjKey"
                    link
                    >
                     <v-btn @click="ActivateSelectedMain(main)">
                        <v-icon>{{main.icon}}</v-icon>
                            <v-badge color="warning" v-if="main.notifications" left>
                        <span slot="badge"> {{main.notifications}}</span>
                        </v-badge>
                    </v-btn>
                    </v-list-item>
                    
                </v-list>
                </v-navigation-drawer>
             <v-navigation-drawer :right="MainDialRight" :app="MiniView" class="elevation-2" :style="MainDialStyling" v-if="SelectedMainDialog && !PublicNavbarEditing" v-model="SelectedMainDialog">
                <v-list v-if="SelectedMain">       
                     <v-card flat  v-if="SelectedMain.PreDialog">
                         <v-card-title class="settingsfont">
                               {{SelectedMain.title}}<v-spacer></v-spacer><v-icon @click="SelectedMain = ''">mdi-chevron-left</v-icon>
                            </v-card-title>                            
                            <v-card-text class="settingsfont" v-if="SelectedMain.IMG">
                                <v-img :src="SelectedMain.IMG"/>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-html="SelectedMain.Writeup">
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer>
                                </v-spacer>
                                <v-btn @click="ActivateSelectedMain(SelectedMain,true)">
                                Go
                                </v-btn>
                            </v-card-actions>
                     </v-card>            
                        <v-card flat  v-if="!SelectedMain.PreDialog">
                            <v-card-title class="settingsfont">
                                {{SelectedMain.title}}<v-spacer></v-spacer><v-icon @click="SelectedMain = ''">mdi-chevron-left</v-icon>
                            </v-card-title>
                             <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Web Forms'">
                                 <v-list class="transparent">
                                     <!-- uhm little something jsut asking. we don't want any quick config on web forms? -->
                                        <v-list-item style="padding-left: 0px;">
                                            <v-chip @click="NavigatetoWebFormBuilder()" >Add Web Form <v-icon>mdi-plus</v-icon></v-chip>
                                        </v-list-item>
                                        <v-list-item @click="NavigatetoWebFormEditor(webform.id)"
                                        dense v-for="webform in WebForms" :key="webform.itemObjKey"
                                        :style="'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'"
                                        >
                                        {{webform.DisplayName}}
                                        </v-list-item>
                                 </v-list>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Page Layout'">
                                <v-list dense class="transparent">
                                    <v-switch dense v-model="TransposedRowsandCols" label="Row Col Transpose'"
                                    @change="ToggleTransposedRowsandCols(TransposedRowsandCols)"
                                    />	
                                    <v-switch dense v-model="MovePageTabs" label="Move Menu Items"
                                    />			
                                    	
                                    <v-list v-for="(tab,i) in PageTabs" :key="tab.itemObjKey">									
                                    <v-list-item									
                                    @dragover.prevent @drop.prevent="Tabdragfinish(i, $event)">									
                                        <v-list-item-avatar size="20">									
                                                    <v-icon v-if="tab.Elements.length>0" small style="display:block;" :id="i+'ShowElementsConfig'" @click="ShowTabElements(i)">mdi-chevron-down</v-icon>									
                                                    <v-icon small style="display:none;" :id="i+'HideElementsConfig'" @click="HideTabElements(i)">mdi-chevron-up</v-icon>									
                                                </v-list-item-avatar>									
                                        <v-list-item-title  :draggable="true" @dragstart="Tabdragstart(tab,i, $event)" @click="OpenDialog(tab,i)">{{tab.Name? tab.Name : tab.DataViewName}}</v-list-item-title>									
                                             <v-list-item-avatar v-if="userIsAdmin && !MovePageTabs" size="20" @click.prevent="AddRAPresetDialog(tab)">									
                                                    <v-icon small class="links--text actionicon">mdi-content-save</v-icon>									
                                                </v-list-item-avatar>	
                                            <v-list-item-avatar v-if="!MovePageTabs" size="20">			
                                                						<!-- @click.prevent="AdjustRowAmount(tab,i)" -->
                                                    <v-icon small class="links--text actionicon">mdi-plus-thick</v-icon>									
                                                </v-list-item-avatar>									
                                               <v-list-item-avatar @click="MoveItemMenuPos(i,'Up','PageTabs')" v-if="MovePageTabs" size="15" >
                                                   <v-icon :disabled="i === 0" x-small class="links--text actionicon">mdi-chevron-up</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-avatar @click="MoveItemMenuPos(i,'Down','PageTabs')"  v-if="MovePageTabs" size="15" >
                                                   <v-icon :disabled="i === PageTabs.length-1" x-small class="links--text actionicon">mdi-chevron-down</v-icon>	
                                                </v-list-item-avatar>									
                                                									
                                    </v-list-item>									
                                    <v-list :id="i+'ElementsConfig'" style="display:none;padding-left:5px;">									
                                                <!--  @click="OpenDialog(elmnt,elmntindex,true,i),ShowTabElements(i)"	 -->
                                                <v-list-item									
                                                    @click="ShowTabElements(i)"									
                                                    v-for="(elmnt, elmntindex) in tab.Elements"									
                                                    :key="elmnt.itemObjKey"									
                                                    link									
                                                    @dragover.prevent @drop.prevent="Elmntdragfinish({tab:tab,i:i,elmnt:elmnt,elmntindex:elmntindex})"									
                                                >	
                                                <!-- not just if user is admin...if users allwoed to create marketplace Templates then it is there -->
                                                
                                                <v-list-item-avatar v-if="userIsAdmin && !MovePageTabs" size="20" @click.prevent="AddRAPresetDialog(elmnt)">									
                                                    <v-icon small class="links--text actionicon">mdi-content-save</v-icon>									
                                                </v-list-item-avatar>									
                                                    <v-list-item-title v-text="elmnt.Name? elmnt.Name : elmnt.DataViewName"									
                                                    :draggable="true" @dragstart="Elmntdragstart(tab,i,elmnt,elmntindex, $event)"></v-list-item-title>									
									
                                                    <v-list-item-icon>									
                                                    <v-icon class="blue--text" v-text="elmnt.Icon"></v-icon>									
                                                    </v-list-item-icon>	
                                                    <v-list-item-avatar @click="MoveItemMenuPos(elmntindex,'Up',tab.Elements)" v-if="MovePageTabs" size="15" >
                                                   <v-icon :disabled="elmntindex === 0" x-small class="links--text actionicon">mdi-chevron-up</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-avatar @click="MoveItemMenuPos(elmntindex,'Down',tab.Elements)"  v-if="MovePageTabs" size="15" >
                                                   <v-icon :disabled="elmntindex === tab.Elements.length-1" x-small class="links--text actionicon">mdi-chevron-down</v-icon>	
                                                </v-list-item-avatar>						
                                                </v-list-item>									
                                    </v-list>									
                                    </v-list>		
                                </v-list>
                            </v-card-text>
                            <!-- Adding a Library would be like featuring a new member, it won't be done like this from here we will only add pages.
                            Selecting a different member would be from the builderviewappbar dropdown
                                <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Documentation Libraries'">
                                 <v-list class="transparent">
                                     <p>Create and maintain a Documentation Library, whereby you can explain services or anythign to your clients and/or users</p>
                                        <v-menu nudge-right="30" 								
                                            :close-on-content-click="false"                            									
                                            transition="scale-transition"                            									
                                            >									
                                            <template v-slot:activator="{ on }">	
                                            <v-chip 
                                            v-on="on" style="z-index:250;"
                                            icon fab small
                                            >
                                             Add Library
                                            </v-chip>
                                            </template>
                                            <v-card flat width="200">
                                                <v-list style="padding: 0px;" dense class="transparent">
                                                    <v-list-item @click="AddDocumentationLibrary('Public')">
                                                        Public
                                                    </v-list-item>
                                                    <v-list-item @click="AddDocumentationLibrary('Members Only')">
                                                        Members Only
                                                    </v-list-item>
                                                </v-list>
                                            </v-card>
                                        </v-menu>
                                        <v-list-item @click="NavigatetoLibraryEditor(doclib)"
                                        dense v-for="doclib in DocumentationLibraries" :key="doclib.itemObjKey"
                                        :style="'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'"
                                        >
                                        {{doclib.Name}}
                                        </v-list-item>
                                 </v-list>
                            </v-card-text> -->
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Add Content'">
                                 <v-tabs>
                            <v-tab>Factory</v-tab>
                            <v-tab-item>
                                 <v-row dense>									
                                <v-col cols="6" md="4"									
                                 v-for="block in RenderedContentBlocks" :key="block.itemObjKey">									
                                    <v-card outlined height="100" class="mx-2" width="100%" @dragend="CancelDrag()"	
                                     @click="AddTabBelow(block)"								
                                :draggable="true" @dragstart="blockdragstart(block, $event)"> 
                                    <v-list-item two-line>
                                        <v-list-item-content >
                                        <v-avatar tile size="40">
                                            <v-icon size="40">{{block.Icon}}</v-icon>
                                        </v-avatar>

                                        <v-card-subtitle style="text-align:center;line-height:1;padding:0;" class="caption">
                                        {{block.DataViewName? block.DataViewName : block.Name}} 
                                        </v-card-subtitle>
                                </v-list-item-content>
                                    </v-list-item>
                            </v-card>									
                                    </v-col>									
                                </v-row>
                            </v-tab-item>
                            <v-tab>My Stored Tabs
                            </v-tab>
                            <v-tab-item>
                                 <v-row dense>									
                                <v-col cols="6" md="4"									
                                 v-for="block in ActiveFeaturedMemberPresets" :key="block.itemObjKey">									
                                    <v-card @click="AddTabBelow(block)" outlined height="100" class="mx-2" width="100%" @dragend="CancelDrag()"									
                                :draggable="true" @dragstart="blockdragstart(block, $event)"> 
                                    <v-list-item two-line>
                                        <v-list-item-content >
                                        <v-avatar tile size="40">
                                            <v-icon size="40">{{block.Icon}}</v-icon>
                                        </v-avatar>

                                        <v-card-subtitle style="text-align:center;line-height:1;padding:0;" class="caption">
                                        {{block.Preset_Name}} 
                                        </v-card-subtitle>
                                </v-list-item-content>
                                    </v-list-item>
                            </v-card>									
                                    </v-col>									
                                </v-row>
                            </v-tab-item>
                                 </v-tabs>
                            </v-card-text>
                          
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Site Menu & Pages' && SelectedNavbar || SelectedMain.title === 'Site Menu & Pages' && IsGroupView">
                                
                                <v-overflow-btn style="width:200px;padding-top:5px;"
                                :items="NavbarItems" disabled :placeholder="'Navbar: '+SelectedNavbar.Name" v-model="SelectedNavbar"
                                item-text="Name"
                                    class="elevation-0 noborderoverflow"
                                    dense return-object
                                    ></v-overflow-btn>
                                    <v-btn v-if="userIsAdmin || userLoggedIn.IsWebDeveloper"  @click="ActivateTemplateDialog('Site')" small outlined color="success"><v-icon>mdi-cash-register</v-icon>Market</v-btn>
                                    <v-list class="transparent">
                                        <v-list-item style="padding-left: 0px;">
                                            <v-chip @click="AddNewPage(SelectedNavbar)" >Add Page <v-icon>mdi-plus</v-icon></v-chip>
                                            <v-chip @click="UpdateMenu()" dark color="success"><v-icon>mdi-content-save</v-icon>Save
                                            </v-chip>
                                        </v-list-item>
                                       
                                    <v-switch dense v-model="MoveMenuPages" label="Move Menu Items"
                                    />
                                     
                                    <!-- here is where we put the navigation style -->
                                        <NavMenuPages :CanNavigate="true" v-for="(page,pageindex) in ComputedNavbarPages" :key="page.itemObjKey" :SelectedNavbar="SelectedNavbar"
                                        :page="page" :pageindex="pageindex" @OnePropEmit="OnePropEmit" @TwoPropsEmit="TwoPropsEmit" @FourPropsEmit="FourPropsEmit"
                                        :System="System" :SystemEntities="SystemEntities"
                                        :MoveMenuPages="MoveMenuPages" :Navlist="NavListArray"
                                        />
                                    </v-list>
                            </v-card-text>
                            
                            
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Page Design'">
                                <v-list-item @click="ActivatePageBGDialog()" >
                                <span v-if="EditedPage.PageBGAsset" style="--col: #04AA6D"  class="texbtn btnhover elevation-1">
                            <v-icon style="--col: #04AA6D"  class="btnhover" small>mdi-file</v-icon>Change BG Image
                            </span><span v-if="!EditedPage.PageBGAsset" style="--col: #04AA6D"  class="texbtn btnhover elevation-1">
                                <v-icon style="--col: #04AA6D"  class="btnhover" small>mdi-file</v-icon>Select BG Image
                            </span>
                                </v-list-item>
                            <v-select @change="AssignSocialItemInteractMethod('UpdatePageHeadersFont',EditedPage.PageHeadersFont)" v-model="EditedPage.PageHeadersFont" label="Headers Font"                                  
                                :items="FontOptions">
                                <template v-slot:item="{ item }">
                                    <span :style="'font-family:'+item">{{item}}
                                        <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                        </p>
                                        </span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span :style="'font-family:'+item">{{item}}</span>
                                </template>
                                </v-select>
                                <v-select @change="AssignSocialItemInteractMethod('UpdatePageContentFont',EditedPage.PageContentFont)" v-model="EditedPage.PageContentFont" label="Body Font"                                   
                                    :items="FontOptions">
                                <template v-slot:item="{ item }">
                                    <span :style="'font-family:'+item">{{item}}
                                        <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                        </p>
                                        </span>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <span :style="'font-family:'+item">{{item}}</span>
                                </template>
                                </v-select>	
                                <v-select label="Header size" @change="AssignSocialItemInteractMethod('UpdatePageHeadersFontSize',EditedPage.PageHeadersFontSize)"
                                v-model="EditedPage.PageHeadersFontSize" :items="[24,36,42,50]"									
                                    />	
                            <v-divider vertical></v-divider>
                                    <v-autocomplete @change="AssignSocialItemInteractMethod('UpdatePageBGColor',EditedPage.PageBGColor)"
                                    :items="STDCSSColors" clearable label="Page BG Color" item-text="Name" v-model="EditedPage.PageBGColor">
                                        <template v-slot:item="{ item }">
                                            <span :style="'background-color:'+item.HEX">{{item.Name}}
                                                <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                                </p>
                                                </span>
                                        </template>
                                    </v-autocomplete>
                            <v-spacer></v-spacer>
                                <v-list-item>
                                    <v-text-field label="Page BG Gradient"
                                     @change="AssignSocialItemInteractMethod('UpdatePageBGGradient',EditedPage.PageBGGradient)"
                                     clearable v-model="EditedPage.PageBGGradient"/>
                                </v-list-item>
                                <v-list-item>									
                                    <a href="https://cssgradient.io/" target="_blank">Get Code</a>	
                                </v-list-item>
                            </v-card-text>
                            <v-card-text class="settingsfont" v-if="SelectedMain.title === 'Media'">
                                <AssetsDirectory :Assets="SystemAssets" :Cols="6" :HoverPreview="true" @ActivateFullGallery="ActivateFullGallery" :ViewFullGalleryBottom="true"
                                :HideSelect="true" :Slice="6"
                                 :ViewFullGalleryText="'See More'"
                                />
                                
                            </v-card-text>
                        </v-card>
                    </v-list>
                </v-navigation-drawer>
                <v-bottom-sheet persistent v-model="Incomplete" hide-overlay>
                     <v-card width="100%" height="100%" flat tile style="background-color: rgba(255,255,255,0.9)"> 
                    <v-card-title class="justify-center background darken-1" style="padding:5px;font-weight: 300!important;">                        
                        {{ProgressStepItem ? 'Step '+(ProgressStepItem.Check)+' of '+ComputedProgressItem.Steps : ''}}
                        <svg v-if="Incomplete && ProgressStepItem && ProgressStepItem.Completed" style="width:40px;display: block;margin: 15px;" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                        <circle class="progressiconpath circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                        <polyline class="progressiconpath check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                        </svg>
                     <svg v-if="Incomplete && ProgressStepItem && !ProgressStepItem.Completed" style="width:40px;display: block;margin: 15px;" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                       <circle class="progressiconpath circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                        <line class="progressiconpath line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
                        <line class="progressiconpath line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
                        </svg>
                    </v-card-title>
                     <v-card-title class="progresstooltip justify-center background darken-1" style="padding:5px;font-weight: 300!important;"
                     >    
                     
                     <span v-html="ProgressStepItem ? ProgressStepItem.Toolip : 'Select an item'">
                     </span>   
                    </v-card-title>
                    <v-btn right absolute top outlined dark @click="CancelProgressSheet()" color="red" style="z-index: 2;">Cancel
                    </v-btn> 
                    <v-card-text>
                        <v-window v-model="step">
                        <v-window-item :value="1">
                            <v-card-text>
                            <!-- here we wimply need to let you toggle "Site Menu & Pages" -->
                          
                            <v-list-item class="justify-center"
                                v-for="main in SingleNavItem('Site Menu & Pages')"
                                :key="main.itemObjKey"
                                link
                                >
                                 <v-btn @click="ActivateSelectedMain(main)">
                                    {{main.title}} <v-icon>{{main.icon}}</v-icon>
                                        <v-badge color="warning" v-if="main.notifications" left>
                                    <span slot="badge"> {{main.notifications}}</span>
                                    </v-badge>
                                </v-btn>
                                </v-list-item>
                        </v-card-text>
                        </v-window-item>
                        <v-window-item :value="2">
                            <v-card-text>
                                   <v-text-field
                                label="Email"
                                :rules="[$store.state.formrules.email]"
                                v-model.trim="Site.Email"
                            ></v-text-field>
                            <v-text-field type="text" v-model="Site.Mobile_Number" placeholder="Mobile Number" size="12" :rules="[$store.state.formrules.telnr]"/>
                        <ContentEditableField style="padding:15px;"
                        :FieldObject="Site" :FieldName="'Overview'"
                        :FieldValue="Site.Overview" @UpdateContentEditableField="UpdateContentEditableField" :AdditionalSaveMethod="''" />
                        <!-- okay no, this won't work..when adding a new keyword how would it enter the registry? -->
                       
                            </v-card-text>
                        </v-window-item>
                         <v-window-item :value="3">
                            <v-card-text>
                                
                                <v-combobox
                                v-model="Site.KeyWords"
                                :items="SiteKeyWordOptions"
                                label="KeyWords"
                                return-object
                                item-text="Name"
                                multiple
                                chips
                                >
                                </v-combobox>
                                <v-select v-model="Site.DefaultPage" :items="Site.Pages" item-text="id" label="Default Page" />
                                <v-img v-if="Site.Profile_Photo && !AddingProfilePhoto" contain :src="Site.Profile_Photo.fileurl" width="140">               
                                    <v-row style="left: 12px;position: absolute; bottom: 40px;width: 100%;height:50px;padding-top:10px;background: linear-gradient(180deg, rgba(222,221,221,0.5) 0%, rgba(222,221,221,0.5) 100%);">
                                    <v-chip @click="ActivateGalleryDialog('Profile_Photo')" :class="$vuetify.theme.dark ? 'mx-3' : 'white mx-3'">Change</v-chip>
                                    </v-row>
                                </v-img>
                                <v-img class="actionbounce" v-if="!Site.Profile_Photo && !AddingProfilePhoto" contain :src="require('@/assets/logo.png')" width="140" style="text-align: -webkit-center;">	
                                <v-row style="left: 12px;position: absolute; bottom: 40px;width: 100%;height:50px;padding-top:10px;background: linear-gradient(180deg, rgba(222,221,221,0.5) 0%, rgba(222,221,221,0.5) 100%);">
                                    <v-chip @click="ActivateGalleryDialog('Profile_Photo')" :class="$vuetify.theme.dark ? 'mx-3' : 'white mx-3'">Change</v-chip>
                                    </v-row>
                                </v-img>
                                 <v-list>
                                    <v-list-item v-for="field in AdditionalFields" :key="field.itemObjKey">
                                         <FieldValueEditerComponent @UpdateEditableField="UpdateEditableField" :Record="ActiveFeaturedMember" :field="field" @onPhotoFileselected="onPhotoFileselected"
                                :CurrentEntity="{}" @UploadFileSelect="UploadFileSelect" @SaveDocumentField="SaveDocumentField"
                                :SystemEntities="SystemEntities" :PrimaryFieldName="'Name'" :RelatedObj="''" :AppisDarkMode="AppisDarkMode" @onPhotoUpload="onPhotoUpload"
                                    />
                                    </v-list-item>
                                 </v-list>
                            </v-card-text>
                        </v-window-item>
                         <v-window-item :value="4">
                            <v-card-text>
                                <v-row class="justify-center">
                                    <v-col cols="6">
                                        <v-list-item>
                                            <v-switch v-model="Site.PublicNavbarDark" label="Bar is Dark"
                                        />
                                        </v-list-item>
                                        <v-list-item>
                                        <v-select label="Type" :items="['Default','STD Bar']" v-model="Site.PublicNavbarStyle"/>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="6">
                                            <v-list-item>
                                        Navbar Text
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="200px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-icon right v-on="on">mdi-palette-advanced</v-icon>
                                            </template>
                                            <v-color-picker v-model="Site.PublicNavbarText"></v-color-picker>
                                            </v-menu>
                                            </v-list-item>
                                            <v-list-item>
                                        Selected Navbar Text
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="200px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-icon right v-on="on">mdi-palette-advanced</v-icon>
                                            </template>
                                            <v-color-picker v-model="Site.PublicNavbarSelectedText"></v-color-picker>
                                            </v-menu>
                                            </v-list-item>
                                            <v-list-item>
                                        Selected Item BG
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="200px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-icon right v-on="on">mdi-palette-advanced</v-icon>
                                            </template>
                                            <v-color-picker v-model="Site.PublicNavbarItemSelectBG"></v-color-picker>
                                            </v-menu>
                                            </v-list-item>
                                            <v-list-item>
                                        Hover Item BG
                                        <v-menu
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="200px"
                                            >
                                            <template v-slot:activator="{ on }">
                                                <v-icon right v-on="on">mdi-palette-advanced</v-icon>
                                            </template>
                                            <v-color-picker v-model="Site.PublicNavbarItemHoverBG"></v-color-picker>
                                            </v-menu>
                                            </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="5">
                            <v-card-text>
                                 <v-list-item class="justify-center">
                                    Check your Vcard details
                                 </v-list-item>
                                 <v-list-item class="justify-center">
                                    <v-btn style="width:150px;" :href="VCardLink">VCard
                                    <v-icon>mdi-card-account-details</v-icon>
                                    </v-btn>
                                </v-list-item>
                                <v-list-item class="justify-center">
                                    Get and Test your QR Code details
                                 </v-list-item>
                                <v-list-item class="justify-center">
                                <v-btn style="width:150px;" :disabled="!FullMemberURL"
                                @click="DownloadQR(ClientAppURL,'/FeaturedMember/',FullMemberRoute,FullMemberName+' - Featured Member QR')"
                                dark width="150px">
                                QR Code
                                <v-icon>mdi-qrcode</v-icon>
                                </v-btn>
                                </v-list-item>
                                  <v-list-item class="justify-center">
                                    When ready, publish
                                 </v-list-item>
                                 <v-list-item class="justify-center">
                                    <v-switch v-model="Site.Published" label="Publish">
                                    </v-switch>
                                 </v-list-item>
                                
                            </v-card-text>
                        </v-window-item>
                        </v-window>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            :disabled="step === 1"
                            text
                            @click="RegressStep()"
                        >
                            Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <!--  :disabled="step === 3" -->
                        <v-btn dark
                            :color="step === 5 ? 'success' : 'blue'"
                            depressed :disabled="CurrentStepFail"
                            @click="AdvanceSetupStep()"
                        >
                            {{step === 5 ? 'Save' : 'Next'}}
                        </v-btn>
                        </v-card-actions>
                     </v-card>
                </v-bottom-sheet>
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import ContentEditableField from '@/components/Database/ContentEditableField'
import AssetsDirectory from '@/components/WebPages/ConfigComponents/AssetsDirectory';	
import NavMenuPages from '@/components/SuiteBuilder/Navigators/NavMenuPages';	
import FieldValueEditerComponent from '@/components/Database/FieldValueEditerComponent';
export default {
    props: ['System','SystemEntities','SitePages','SocialEntities','PublicNavbarEditing','Directories',
    'SystemPhotoLibraries','WebFormEntities','GroupEntities','GraphicalElements','GradientElements','DocumentationLibraries'],
    components: {
        ContentEditableField,
        AssetsDirectory,
        NavMenuPages,
        FieldValueEditerComponent,
    },
    data() {
        return {  
            AddingProfilePhoto: false,
            step: 1,
            Incomplete: false,
            //ComputedActiveFeaturedMember
            ActiveProgressItem: {title: 'Site General',ViewName: 'SiteGeneralView',icon: 'mdi-cogs',StepRequirements: [
          {Check: 1, Name: 'Creating Pages',ParentObj: 'ActiveFeaturedMember',Prop: {Name: 'Pages_Created',DisplayName: 'Has Pages',Type: 'Object',ChildProps: [
            {Name: 'Pages',DisplayName: 'Has Pages',Type: 'Array',Checking: 'Length'}
          ]},
          Optional: false,Toolip: `<p>You need to create some pages, or choose from a template</p>`},
          {Check: 2, Name: 'Basic Info',ParentObj: 'ActiveFeaturedMember',Prop: {Name: 'Basic_Info',Type: 'Object',ChildProps: [
            {Name: 'Email',DisplayName: 'Email',Type: 'Common Field',CommonFieldType: 'Email'},
            {Name: 'Mobile_Number',DisplayName: 'Mobile Number',Type: 'Common Field',CommonFieldType: 'Phone Number'},
            {Name: 'Overview',DisplayName: 'Overview',Type: 'Multiple Lines Text',IsContentEditable: true}
          ]},
          Toolip: `<p>Adding contact information helps people get in contact with you. This information will also  become available on your electronic contact card.</p>`},
          {Check: 3, Name: 'Listing',ParentObj: 'ActiveFeaturedMember',Prop: {Name: 'Listing_Info',Type: 'Object',ChildProps: [
            {Name: 'KeyWords',DisplayName: 'Keywords',Type: 'Array',Checking: 'Length'},
            {Name: 'DefaultPage',DisplayName: 'Default Page',Type: 'Option Set',Check: 'Present'},
            {Name: 'Profile_Photo',DisplayName: 'Profile Picture',Type: 'Single File Upload',FeaturedPhoto: true}
          ]},
          //decided that step 1 simply let's you toggle site menu pages menu so in that case when adding pages...why not menu same time? right?
        //   Toolip: `<p>This information makes it easy for people to find you in members directory.</p>`},
        //   {Check: 4, Name: 'Menu Items',ParentObj: 'ActiveFeaturedMember',Prop: {Name: 'Menu_Items',Type: 'Object',ChildProps: [
        //     {Name: 'MenuItems',DisplayName: 'Menu Items',Type: 'Color',Checking: 'Length'}
        //   ]},
          Toolip: `<p>This information makes it easy for people to find you in members directory.</p>`},
          {Check: 4, Name: 'Menu Styling',ParentObj: 'ActiveFeaturedMember',Prop: {Name: 'Menu_Styling',Type: 'Object',ChildProps: [
            {Name: 'PublicNavbarDark',DisplayName: 'Navbar Mode',Type: 'Boolean',Optional: true},
            {Name: 'PublicNavbarStyle',DisplayName: 'Navbar Style',Type: 'Option Set',Optional: true},{Name: 'PublicNavbarText',DisplayName: 'Navbar Text',Type: 'Color Set',Optional: true},
            {Name: 'PublicNavbarSelectedText',DisplayName: 'Selected Item Color',Type: 'Option Set',Optional: true},{Name: 'PublicNavbarItemSelectBG',DisplayName: 'Selected Item BG',Type: 'Color Set',Optional: true},
            {Name: 'PublicNavbarItemHoverBG',DisplayName: 'Hover Item BG',Type: 'Option Set',Optional: true},
          ]},
          Toolip: `<p>Style your portfolio's navigational menu to your liking.</p>`},
          {Check: 5, Name: 'Review and Publish',ParentObj: 'ActiveFeaturedMember',Prop: {Name: 'Published',Type: 'Boolean'},
          Toolip: `<p>Let's review and publish your portfolio!</p>`},
          ]},
            VCardLink: '',
            rules: {
            telnr: value => {
            const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
            return pattern.test(value) || "Not a telephone number.";
          },
            min8Chars: value => value.length >= 8 || "Min. 8 characters",
            required: value => !!value || "Required.",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            },
            url: value => {
                const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); 
                return urlpattern.test(value) || "Invalid Link.";
            }
            },
            Site: '',
            MoveMenuPages: false,
            MovePageTabs: false,
            TransposedRowsandCols: false,   
            ContentBlockClasses: [
                'Parallax',
                'Text',
                'Titles',
                'Images',
                'Gallery',
                'Call to Action',                                
                'Lists',
                'Links',
                'Feeds',
                'Misc',
                'Graphics',
                'Custom'
            ],       
            AddingBlocks: [],
            BulkContentBlocktoPresetDialog: false,
            BulkContentPresetStep: 1,
            BulkContenttoPresetIndex: -1,
            RAPresetTab: {
                Preset_Name: '',
                Database: 'Client'
            },
            DefaultRAPresetTab: {
                Preset_Name: '',
                Database: 'Client'
            },
            RAPresetDialog: false,
            AppStylingIMGProp: '',
            LibraryColors: [
        'red',
        'white',
        'black',
        'pink',
        'purple',
        'indigo',
        'blue',
        'light-blue',
        'cyan',
        'teal',
        'green',
        'light-green',
        'lime',
        'yellow',
        'amber',
        'orange',
        'deep-orange',
        'brown',
        'blue-grey',
        'grey'
      ],
            Company_Address: {Name: 'Company_Address',FieldBreakdown: [],DisplayName: 'Company Address',CommonFieldType: 'Physical Address',Type: 'Common Field'},
            GalleryLibraries: [],
            FontOptions: ['Architects Daughter','Bahianita','Bangers','Bebas Neue','Berkshire Swash','Caveat','Courgette','Dancing Script','Gudea','Hind','Impact','Indie Flower','Lato','Lobster','Macondo Swash Caps','Maven Pro','Metrophobic','Michroma','Montserrat','Mulish','Mukta Vaani',
                  'News Cycle','Niramit','NTR','Nunito Sans','Oswald','Padauk','Palanquin','Parisienne','Playfair Display','Poiret One','Poppins','Quicksand','Raleway','Redressed','Tangerine','Tulpen One','Verdana','Vibes','Yellowtail'],									
        
            
        SEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        DefaultSEOPage: {
            Overview: '',
            PageRoute: '',
            KeyWords: [],
            Name: '',
            PageIcon: '',
            SEO: false,
        },
        SEOBasicsDialog: false,
        PageBasics: [
            {Label: 'Rename', Prop: 'PageName', Icon: 'mdi-pencil', Menu: false},
            {Label: 'Path', Prop: 'PageRoute', Icon: 'mdi-link', Menu: false},
            {Label: 'Rename', Prop: 'PageIcon', Icon: 'mdi-circle', Menu: false}
        ],
        NavItemIndex: -1,
        NavParentIndex: -1,
        SelectedNavbar: {Name: 'Page Navbar',Prop: 'MenuItems',PublishType: ''},
        SelectedPage: '',
        SelectedMain: '',
        SelectedMainDialog: false,
        STDCSSColors: [{Name: 'aliceblue', HEX: '#f0f8ff'},{Name: 'antiquewhite', HEX: '#faebd7'},{Name: 'aqua', HEX: '#00ffff'},{Name: 'aquamarine', HEX: '#7fffd4'},{Name: 'azure', HEX: '#f0ffff'},{Name: 'beige', HEX: '#f5f5dc'},{Name: 'bisque', HEX: '#ffe4c4'},{Name: 'black', HEX: '#000000'},{Name: 'blanchedalmond', HEX: '#ffebcd'},{Name: 'blue', HEX: '#0000ff'},{Name: 'blueviolet', HEX: '#8a2be2'},{Name: 'brown', HEX: '#a52a2a'},{Name: 'burlywood', HEX: '#deb887'},{Name: 'cadetblue', HEX: '#5f9ea0'},{Name: 'chartreuse', HEX: '#7fff00'},{Name: 'chocolate', HEX: '#d2691e'},{Name: 'coral', HEX: '#ff7f50'},{Name: 'cornflowerblue', HEX: '#6495ed'},{Name: 'cornsilk', HEX: '#fff8dc'},{Name: 'crimson', HEX: '#dc143c'},{Name: 'cyan', HEX: '#00ffff'},{Name: 'darkblue', HEX: '#00008b'},{Name: 'darkcyan', HEX: '#008b8b'},{Name: 'darkgoldenrod', HEX: '#b8860b'},{Name: 'darkgray', HEX: '#a9a9a9'},{Name: 'darkgreen', HEX: '#006400'},{Name: 'darkgrey', HEX: '#a9a9a9'},{Name: 'darkkhaki', HEX: '#bdb76b'},{Name: 'darkmagenta', HEX: '#8b008b'},{Name: 'darkolivegreen', HEX: '#556b2f'},{Name: 'darkorange', HEX: '#ff8c00'},{Name: 'darkorchid', HEX: '#9932cc'},{Name: 'darkred', HEX: '#8b0000'},{Name: 'darksalmon', HEX: '#e9967a'},{Name: 'darkseagreen', HEX: '#8fbc8f'},{Name: 'darkslateblue', HEX: '#483d8b'},{Name: 'darkslategray', HEX: '#2f4f4f'},{Name: 'darkslategrey', HEX: '#2f4f4f'},{Name: 'darkturquoise', HEX: '#00ced1'},{Name: 'darkviolet', HEX: '#9400d3'},{Name: 'deeppink', HEX: '#ff1493'},{Name: 'deepskyblue', HEX: '#00bfff'},{Name: 'dimgray', HEX: '#696969'},{Name: 'dimgrey', HEX: '#696969'},{Name: 'dodgerblue', HEX: '#1e90ff'},{Name: 'firebrick', HEX: '#b22222'},{Name: 'floralwhite', HEX: '#fffaf0'},{Name: 'forestgreen', HEX: '#228b22'},{Name: 'fuchsia', HEX: '#ff00ff'},{Name: 'gainsboro', HEX: '#dcdcdc'},{Name: 'ghostwhite', HEX: '#f8f8ff'},{Name: 'gold', HEX: '#ffd700'},{Name: 'goldenrod', HEX: '#daa520'},{Name: 'gray', HEX: '#808080'},{Name: 'green', HEX: '#008000'},{Name: 'greenyellow', HEX: '#adff2f'},{Name: 'grey', HEX: '#808080'},{Name: 'honeydew', HEX: '#f0fff0'},{Name: 'hotpink', HEX: '#ff69b4'},{Name: 'indianred', HEX: '#cd5c5c'},{Name: 'indigo', HEX: '#4b0082'},{Name: 'ivory', HEX: '#fffff0'},{Name: 'khaki', HEX: '#f0e68c'},{Name: 'lavender', HEX: '#e6e6fa'},{Name: 'lavenderblush', HEX: '#fff0f5'},{Name: 'lawngreen', HEX: '#7cfc00'},{Name: 'lemonchiffon', HEX: '#fffacd'},{Name: 'lightblue', HEX: '#add8e6'},{Name: 'lightcoral', HEX: '#f08080'},{Name: 'lightcyan', HEX: '#e0ffff'},{Name: 'lightgoldenrodyellow', HEX: '#fafad2'},{Name: 'lightgray', HEX: '#d3d3d3'},{Name: 'lightgreen', HEX: '#90ee90'},{Name: 'lightgrey', HEX: '#d3d3d3'},{Name: 'lightpink', HEX: '#ffb6c1'},{Name: 'lightsalmon', HEX: '#ffa07a'},{Name: 'lightseagreen', HEX: '#20b2aa'},{Name: 'lightskyblue', HEX: '#87cefa'},{Name: 'lightslategray', HEX: '#778899'},{Name: 'lightslategrey', HEX: '#778899'},{Name: 'lightsteelblue', HEX: '#b0c4de'},{Name: 'lightyellow', HEX: '#ffffe0'},{Name: 'lime', HEX: '#00ff00'},{Name: 'limegreen', HEX: '#32cd32'},{Name: 'linen', HEX: '#faf0e6'},{Name: 'magenta', HEX: '#ff00ff'},{Name: 'maroon', HEX: '#800000'},{Name: 'mediumaquamarine', HEX: '#66cdaa'},{Name: 'mediumblue', HEX: '#0000cd'},{Name: 'mediumorchid', HEX: '#ba55d3'},{Name: 'mediumpurple', HEX: '#9370db'},{Name: 'mediumseagreen', HEX: '#3cb371'},{Name: 'mediumslateblue', HEX: '#7b68ee'},{Name: 'mediumspringgreen', HEX: '#00fa9a'},{Name: 'mediumturquoise', HEX: '#48d1cc'},{Name: 'mediumvioletred', HEX: '#c71585'},{Name: 'midnightblue', HEX: '#191970'},{Name: 'mintcream', HEX: '#f5fffa'},{Name: 'mistyrose', HEX: '#ffe4e1'},{Name: 'moccasin', HEX: '#ffe4b5'},{Name: 'navajowhite', HEX: '#ffdead'},{Name: 'navy', HEX: '#000080'},{Name: 'oldlace', HEX: '#fdf5e6'},{Name: 'olive', HEX: '#808000'},{Name: 'olivedrab', HEX: '#6b8e23'},{Name: 'orange', HEX: '#ffa500'},{Name: 'orangered', HEX: '#ff4500'},{Name: 'orchid', HEX: '#da70d6'},{Name: 'palegoldenrod', HEX: '#eee8aa'},{Name: 'palegreen', HEX: '#98fb98'},{Name: 'paleturquoise', HEX: '#afeeee'},{Name: 'palevioletred', HEX: '#db7093'},{Name: 'papayawhip', HEX: '#ffefd5'},{Name: 'peachpuff', HEX: '#ffdab9'},{Name: 'peru', HEX: '#cd853f'},{Name: 'pink', HEX: '#ffc0cb'},{Name: 'plum', HEX: '#dda0dd'},{Name: 'powderblue', HEX: '#b0e0e6'},{Name: 'purple', HEX: '#800080'},{Name: 'red', HEX: '#ff0000'},{Name: 'rosybrown', HEX: '#bc8f8f'},{Name: 'royalblue', HEX: '#4169e1'},{Name: 'saddlebrown', HEX: '#8b4513'},{Name: 'salmon', HEX: '#fa8072'},{Name: 'sandybrown', HEX: '#f4a460'},{Name: 'seagreen', HEX: '#2e8b57'},{Name: 'seashell', HEX: '#fff5ee'},{Name: 'sienna', HEX: '#a0522d'},{Name: 'silver', HEX: '#c0c0c0'},{Name: 'skyblue', HEX: '#87ceeb'},{Name: 'slateblue', HEX: '#6a5acd'},{Name: 'slategray', HEX: '#708090'},{Name: 'slategrey', HEX: '#708090'},{Name: 'snow', HEX: '#fffafa'},{Name: 'springgreen', HEX: '#00ff7f'},{Name: 'steelblue', HEX: '#4682b4'},{Name: 'tan', HEX: '#d2b48c'},{Name: 'teal', HEX: '#008080'},{Name: 'thistle', HEX: '#d8bfd8'},{Name: 'tomato', HEX: '#ff6347'},{Name: 'turquoise', HEX: '#40e0d0'},{Name: 'violet', HEX: '#ee82ee'},{Name: 'wheat', HEX: '#f5deb3'},{Name: 'white', HEX: '#ffffff'},{Name: 'whitesmoke', HEX: '#f5f5f5'},{Name: 'yellow', HEX: '#ffff00'},{Name: 'yellowgreen', HEX: '#9acd32'},
],
        TopItems: [ { title: 'Main', icon: 'mdi-subdirectory-arrow-left',Menu: false,Route: 'SystemConfig/'+process.env.VUE_APP_RA_SYSTEM_ID},],
        sitenavitems: [
       //Adding a Library would be like featuring a new member, it won't be done like this from here we will only add pages.
                            //Selecting a different member would be from the builderviewappbar dropdown
       // { title: 'Documentation Libraries', icon: 'mdi-book-education' ,Menu: false,},
          { title: 'Site Menu & Pages', icon: 'mdi-home-city',Menu: false},         
        { title: 'Add Content', icon: 'mdi-plus',Menu: false},
          { title: 'Page Design', icon: 'mdi-palette' ,Menu: false},
          { title: 'Page Layout', icon: 'mdi-monitor-dashboard' ,Menu: false},          
        //   { title: 'Media', icon: 'mdi-folder-image' ,Menu: false},
        //    { title: 'FAQ', icon: 'mdi-account-question' ,Menu: false, Route: 'FAQAdmin',
        //     PreDialog: true,
        //     IMG: require('@/assets/logo.png'),
        //     Writeup: `<p>Create and maintain a list of Frequently Asked Questions to add to your Website Pages</p>`
        //     },
            // { title: 'Chatbot', icon: 'mdi-robot',Route: 'ChatbotBuilder' ,
            // PreDialog: true,
            // IMG: require('@/assets/logo.png'),
            // Writeup: `<p>Capitalize on FAQ and configure chatbot for responses. Further expand the chatbot with "virtual assist" responses such as "How many Orders were placed last week".</p>`,},
           
        ],
        
        }
    },
    computed:{
        FeaturedMemberNavlist(){
            return this.Directories.find(obj => obj.id === 'Featured_Members')
        },
        AdditionalFields(){
            return this.FeaturedMemberNavlist ? this.FeaturedMemberNavlist.AdditionalFields : []
        },
        CurrentStepFail(){
            let fail = false
            //this.AutoStep <= this.step
            return fail
        },
        ProgressStepItem(){
            return this.ComputedProgressItem && this.ComputedProgressItem.StepRequirements && this.ComputedProgressItem.StepRequirements[this.step-1] ? 
            this.ComputedProgressItem.StepRequirements[this.step-1] : ''
        },
        AutoStep(){
            return this.ComputedProgressItem && this.ComputedProgressItem.IncompletedSteps[0] ? this.ComputedProgressItem.IncompletedSteps[0].Check : ''
        },
        ComputedProgressItem(){
            let item = Object.assign({},this.ActiveProgressItem)
            item.Steps = item.StepRequirements.length
            item.IncompletedSteps = item.StepRequirements.filter(req => {
            let incomplete = false
            //ONE FINAL BAM SMACK OOPS....
            //SEQUENTIAL LOGIC...RIGHT NOW I GET "4 OUT OF 6", BUT I STILL NEED TO COMPLETE STEP 3..
            //KIND OF NEED TO "BREAK" THE LOOP once anything is incomplete, you check?
            //OR we jsut assign "Check" value of the first incomplete right? 
                //basically StepRequirements has changed from initial. 
                //1. Prop was not object now it is, reference .Name
                //2. 1 Check was considered 1 prop. Now, if prop is "Type: Object" it must reference ChildProps, same logic this means
                //2.1. Firstly ensure prop check EXCLUDES Type "Object"
                //2.2. Now, check IF Prop is Object, as all values matching, based on child prop types mind you
            //return !this[req.ParentObj] || this[req.ParentObj] && !this[req.ParentObj][req.Prop.Name] && req.Prop.Type !== 'Object'
                if(!this[req.ParentObj]){
                    incomplete = true
                }
                else if(this[req.ParentObj] && !this[req.ParentObj][req.Prop.Name] && req.Prop.Type !== 'Object'){
                    incomplete = true
                }
                else if(req.Prop.Type === 'Object'){
                    //console.log(req)
                    req.Prop.ChildProps.map(childprp => {
                        //very raw and undefined not checking types Array "Checking" e.g. "Length"
                        if(!this[req.ParentObj][childprp.Name] && !childprp.Optional){
                            incomplete = true
                        }
                        else if(this[req.ParentObj][childprp.Name] && this[req.ParentObj][childprp.Name].length === 0 && childprp.Type === 'Array' && childprp.Checking === 'Length'&& !childprp.Optional){
                            incomplete = true
                        }
                    })
                }
            return incomplete
            })
            item.StepRequirements = item.StepRequirements.map(req => {
                let incompletecheck = item.IncompletedSteps.find(obj => obj.Check === req.Check)
                if(!incompletecheck){
                    req.Completed = true
                }
                return req
            })
            let Incomplete = item.IncompletedSteps.length 
            item.StepsCompleted = item.Steps-Incomplete     
            item.Progress = Math.floor((item.StepsCompleted/item.Steps)*Math.floor(100))
            item.Toolip = `All done`
            if(item.Progress < 100){
                //this was wrong why start with last step right?
                //item.Toolip = item.IncompletedSteps[Incomplete-1].Toolip
            item.Toolip = item.IncompletedSteps[0].Toolip
            }
            return item
        },
        progressvalue(){
        return this.ComputedProgressItem ? this.ComputedProgressItem.Progress : 0
        },
        ClientAppURL(){
            return this.System ? this.System.ClientAppURL.split(' ').join('').split('firebaseapp.com').join('web.app') : ''
        },
        FullMemberName(){
            return this.ActiveFeaturedMember ? this.ActiveFeaturedMember.Full_Name : ''
        },
        FullMemberRoute(){
            return this.ActiveFeaturedMember && this.ActiveFeaturedMember.DefaultPage ?
            this.ActiveFeaturedMember.id+'/'+this.ActiveFeaturedMember.DefaultPage : ''
        },
        FullMemberURL(){
            //return this.ClientAppURL && this.FullMemberName && this.FullMemberRoute ? 
            return this.ClientAppURL && this.FullMemberName && this.FullMemberRoute ? 
            this.ClientAppURL+this.FullMemberRoute : ''
        },
        SiteKeyWordOptions(){
            return this.$store.state.SiteKeyWordOptions.filter(kw => {
                return kw.Type.Name === 'Featured Member'
            })
        },
      IMGProp(){
        return this.$store.state.IMGProp
      },
        WebFormEntities(){
            //this would need to become per feat member
            return []
        },
        PublicNavbarActionOptions(){
        return this.WebFormEntities.map(ent => {
          let actobj = {
            id: ent.id,
            Type: 'Web Form',
            WebFormTab: ent.WebFormTab,
            WebFormType: ent.WebFormType,
            SingleName: ent.SingleName,
            DisplayName: ent.DisplayName
          }
          if(ent.ParentEntity){
            actobj.ParentEntity = ent.ParentEntity
          }
          return actobj
        })
      },
        ActiveFeaturedMemberPresets(){
            return this.ActiveFeaturedMember && this.ActiveFeaturedMember.PagePresets ? this.ActiveFeaturedMember.PagePresets : []
        },
        ActiveDB(){
            //NOTHING FINALIZED HERE. THE MAIN IDEA WAS BUILDING FROM CLIENT SUITE. THE REASON WE DON'T CONTINUE TO PURSUE THIS IS
            //1. WE ARE NOT CALLING GALLERYOBJECTS FOR RA, AND WE SHOULD TRULY NOT
            //2. APPNOTIFICATIONS MAKE STANDARD CLALS WHEN ADDING TO LIBRARIES. we fixed that though
            //mainly then we don't call glalery assets from Ra DB. should we?
            return this.DocumentationLibraryObj && this.DocumentationLibraryObj.Database ? this.DocumentationLibraryObj.Database : db
        },
        DocumentationLibraryObj(){
            let doclibobj = this.DocumentationLibraries.find(obj => obj.id === this.$route.params.id)
            
            if(doclibobj){
                return doclibobj
            }
        },
        ActiveFeaturedMember(){
            
            return this.$store.state.ActiveFeaturedMember
        },
        ActiveDocumentationLibrary(){
            return this.$store.state.ActiveDocumentationLibrary
        },
        MainDialRight(){
            return this.SelectedMain && this.SelectedMain.title === 'App Styling'
        },
        MainDialStyling(){
            return 'position: fixed;left: 88px;top:190px;z-index:6;height:60%;width:270px;'
        },
        AdvancedComputedLibraryColors(){
      let arr1 = this.LibraryColors
      let arr2 = [
        'primary',
        'accent',
        'secondary',
        'pop',
        'morning',
        'night',
        'fieldcard',
        'links',
        'background',
      ]
      let arr3 = arr1.concat(arr2)
      let arr4 = []
      arr3.map(color => {
        arr4.push(color)
        arr4.push(color+' lighten-1')
        arr4.push(color+' lighten-2')
        arr4.push(color+' lighten-3')
        arr4.push(color+' lighten-4')
        arr4.push(color+' lighten-5')
        arr4.push(color+' darken-1')
        arr4.push(color+' darken-2')
        arr4.push(color+' darken-3')
        arr4.push(color+' darken-4')
        arr4.push(color+' darken-5')
        arr4.push(color+' accent-1')
        arr4.push(color+' accent-2')
        arr4.push(color+' accent-3')
        arr4.push(color+' accent-4')
      })
      return arr4
    },
        ActiveAppStylingNavbar(){
     if(this.$route.name === 'MyAccount'){
       return 'Guest Navbar'
     }
     else if(this.DBBuilderView){
        return 'DB Navbar'
      }
      else if(this.WebsiteBuilderView){
        if(this.$route.meta && this.$route.meta.DataSingleBuilder && this.$route.name !== 'SystemConfig'){
          return 'DB Navbar'
        }
        else{
          return 'Public Navbar'
        }
      }
      else if(this.NetworkBuilderView){
        return 'Social Navbar'
      }
   },
        GroupidRoutes(){
            return this.$store.state.GroupidRoutes
        },
        GroupslugRoutes(){
            return this.$store.state.GroupslugRoutes
        },
        GroupID(){
            if(this.GroupidRoutes.includes(this.$route.name)){
                return this.$route.params.id
            }
            else if(this.$route.query && this.$route.query.GroupID){
                return this.$route.query.GroupID
            }
            else if(this.GroupslugRoutes.includes(this.$route.name)){
                return this.$route.params.slug
            }
        },
        WebForms(){
            if(this.IsGroupView){
                return this.GroupEntities.filter(ent => {
                    return ent.Entity_Type && ent.Entity_Type.Name === 'Web Form' && ent.groupid === this.GroupID
                })
            }
            else{
                return this.WebFormEntities
            }
        },
        IsGroupView(){
        return this.$store.state.IsGroupView
    },
        draggingtab(){
            return this.$store.state.draggingtab
        },
        draggingtabindex(){
            return this.$store.state.draggingtabindex
        },
        draggingelement(){
            return this.$store.state.draggingelement
        },
        draggingelementindex(){
            return this.$store.state.draggingelementindex
        },
        draggingrow(){
            return this.$store.state.draggingrow
        },
        draggingrowindex(){
            return this.$store.state.draggingrowindex
        },
        dragging(){
            return this.$store.state.dragging
        },
        NavbarItems(){
            return [{Name: 'Page Navbar',Prop: 'MenuItems',PublishType: ''}]
            // if(this.IsGroupView){
            //     return [{Name: 'Group',Prop: 'GroupNavbarItems',PublishType: ''}]
            // }
            // else{
            //     return [{Name: 'Public',Prop: 'PublicNavbarItems',PublishType: 'Public'},{Name: 'Social',Prop: 'SocialNavbarItems',PublishType: 'Members Only'}]
            // }
        },
        PageTabsPropName(){
            if(this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer){
                return 'SingleBuildTabs'
            }   
            else if(this.$route.meta && this.$route.meta.ClassifiedListingBuilder){
                return 'ClassifiedTabs'
            }
            else if(this.$route.meta && this.$route.meta.WikiListingBuilder){
                return 'WikiTabs'
            }
            else{
                return 'PageTabs'
            }
        //return this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer? 'SingleBuildTabs' : 'PageTabs'
    },		
        PageTabs(){
            //console.log('EditedPage',this.EditedPage)
            return this.EditedPage ? this.EditedPage[this.PageTabsPropName] : []
        },
        EditedPage(){
            return this.$store.state.EditedPage
        },
        RenderedContentBlocks(){
            return this.$store.state.RenderedContentBlocks
        },
        BuilderView(){
        return this.$store.state.BuilderView
        },
        WebsiteBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Website Builder'
        },
        DBBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Database Builder'
        },
        NetworkBuilderView(){
            return this.BuilderView && this.BuilderView.Name === 'Social Network Builder'
        },
        CanEditDocLib(){
            return this.ActiveDocumentationLibrary && !this.DocLibisRADB && this.userIsAdmin
            || this.ActiveDocumentationLibrary && this.DocLibisRADB && this.RAAdmin
        },
        RAAdmin(){
            return this.RAUserObj && this.RAUserObj.rolesarrayDBRules && this.RAUserObj.rolesarrayDBRules.SystemAdmin
        },
        RAUserObj(){
            return this.$store.state.RAUserObj
        },
        RADB(){
            return this.$store.state.RADB
        },
        DocLibisRADB(){
            return this.ActiveDocumentationLibrary && this.ActiveDocumentationLibrary.Database && this.ActiveDocumentationLibrary.Database === this.RADB
        },
        SystemAssets(){
            return this.DocLibisRADB ? this.$store.state.RASystemAssets : this.$store.state.SystemAssets
        },
        MiniView(){
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        SiteDialog(){
            return this.$store.state.SiteDialog
        },
      FilteredTopItems(){
            return this.TopItems.filter(item => {
                if(!this.IsGroupView || this.IsGroupView && this.$route.name === 'GroupEdit'){
                    return item.title !== 'Main'
                }
                else{
                    return item
                }
            }).map(item => {
                if(this.IsGroupView && item.title === 'Main'){
                   item.Route = 'Group/Edit/'+this.GroupID  
                }
                return item
            })
      },
        Computedsitenavitems(){
            return this.sitenavitems.filter(item => {
                if(this.$route.meta.DataSingleBuilder && this.$route.name !== 'SystemConfig'){
                    return item.title === 'Add Content' || item.title === 'Page Layout'
                }
                else if(this.$route.name === 'SystemConfig'){
                    return item.title === 'Site Menu & Pages' || item.title === 'Media'
                }
                else if(this.$route.name === 'newlandingpage'){
                    
                    return item.title !== 'Site Menu & Pages'
                }
                else if(this.IsGroupView && this.$route.name !== 'GroupPageEditor'){                    
                    return item.title !== 'Add Content' && item.title !== 'Chatbot'
                    && item.title !== 'FAQ' && item.title !== 'Page Design' && item.title !== 'Page Layout'
                    //later we will add FAQ back in to groups for sure
                }
                else if(this.IsGroupView){                    
                    return item.title !== 'Chatbot'
                    && item.title !== 'FAQ'
                    //later we will add FAQ back in to groups for sure
                }
                else{
                    return item
                }
            })
        },
        ComputedNavbarPages(){
            return this.NavbarPages.map(page => {
                //console.log('ComputedNavbarPages',page)
                page.OnMenu = false
                let oncheck = this.ComputedNavList.find(obj => obj.id === page.id)
                if(oncheck){
                    page.MenuIndex = oncheck.MenuIndex
                    page.OnMenu = true
                    if(oncheck.Children){
                        page.Children = oncheck.Children.map(child => {
                            let childpageobj = Object.assign({},this.NavbarPages.find(obj => obj.id === child.id))
                            childpageobj.MenuIndex = child.MenuIndex
                            //console.log(child,childpageobj)
                            return childpageobj
                        })
                    }
                }
                // else if(page.SubPage){
                //     page.OnMenu = true
                // }
                else{
                    page.OnMenu = false
                    page.MenuIndex = 100000
                }
                return page
            })
            .filter(page => {
                return !page.SubPage
            })
            .map(page => {
                if(page.OnMenu){
                    page.RenderStyling = 'links--text'
                }
                else{
                    page.RenderStyling = 'grey--text'
                }
                return page
            })
            .sort((a, b) => {
                var key1 = a.MenuIndex;
                var key2 = b.MenuIndex;

                if (key1 < key2) {
                    return -1;
                } else if (key1 == key2) {
                    return 0;
                } else {
                    return 1;
                }
        })
        },
        
        ActiveGroup(){
            return this.$store.state.ActiveGroup
        },
        ComputedSitePages(){
            //console.log('this.ActiveDocumentationLibrary',this.ActiveDocumentationLibrary)
            if(this.IsGroupView){
                //console.log(this.ActiveGroup)
                return this.ActiveGroup && this.ActiveGroup.Pages ? this.ActiveGroup.Pages : []
            }
            else{
                return this.ActiveFeaturedMember.Pages
            }
        },
        NavListArray(){
            return this[this.NavlistHolder] && this.SelectedNavbar && this[this.NavlistHolder][this.SelectedNavbar.Prop] ? this[this.NavlistHolder][this.SelectedNavbar.Prop]
            : []
            //  return this.ActiveFeaturedMember && this.ActiveFeaturedMember.MenuItems ? this.ActiveFeaturedMember.MenuItems
            // : []
        },
        NavlistRef(){
            return db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id)
        },
        NavlistHolder(){
            if(this.IsGroupView){
                return 'ActiveFeaturedMember'
            }
            else{
                return 'ActiveFeaturedMember'
            }
        },
        ComputedNavList(){
            let arr = this.NavListArray
            //console.log(arr)
            return arr.map((item,arrindex) => {
                item.MenuIndex = arrindex
                return item
            })
        },
        NavbarPages(){
           return this.ComputedSitePages        
        },
        DefaultPath(){
            //UpdateSEOBasics
            if(this.$route.name === 'PageEditor'){
                return this.System.ClientAppURL+'/'
            }
            else if(this.IsGroupView){
                return this.System.ClientAppURL+'/Group-Page/'+this.GroupID+'/'
            }
        },
        userLoggedIn () {
        return this.$store.getters.user
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
        SelectedImage(){
        return this.$store.state.SelectedGalleryAsset
      },
       RAStorePagePresets(){
            return this.$store.state.RAStorePagePresets
        },
    },
    watch: {
        ActiveFeaturedMember: {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue && !oldvalue){
                    let props = ['Public_NavBar_IMG','Profile_Photo']
                    props.map(prp => {
                        if(typeof this.ActiveFeaturedMember[prp] !== 'undefined'){
                            this[prp] = this.ActiveFeaturedMember[prp]
                        }
                    })
                    this.SelectedNavbar.PublishType = this.EditedPage.PublishType
                    //this.PrepNavbar(newvalue)
                    
                }
                if(newvalue && newvalue !== oldvalue){
                   this.TransposedRowsandCols = newvalue.TransposedRowsandCols
                }
                this.Site = Object.assign({},this.ActiveFeaturedMember)
                this.DownloadVCard()
            },deep: true

            
        },
        EditedPage : {
            handler: function(newvalue, oldvalue) {
                if(newvalue !== oldvalue && !oldvalue){
                    this.SelectedNavbar.PublishType = this.EditedPage.PublishType
                    //this.PrepNavbar(newvalue)
                    
                }
                if(newvalue !== oldvalue){
                   this.TransposedRowsandCols = newvalue.TransposedRowsandCols
                }
            },deep: true
        },
        SelectedMain (value){
            if(value){
                this.SelectedMainDialog = true
            }
            else{
                this.SelectedMainDialog = false
            }
        },
        SocialItemInteractMethod(v){   
        let acceptedmethods = ['PushtoPreviousNavItem','PrepareSelectedMain','AssignPublicNavbarIMG']   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){
        this.Site = Object.assign({},this.ActiveFeaturedMember)
        if(this.PublicNavbarEditing){
            this.TogglePublicNavbarEditing()
        }
        //console.log(this.$route.name,this.IsGroupView)
        if(this.EditedPage){
            this.TransposedRowsandCols = this.EditedPage.TransposedRowsandCols
        }
        if(this.RAStorePagePresets.length === 0){
            let presetquery = ''
            if(!this.SystemisRA){
                presetquery = this.RADB.collection('pagepresets')
            }
            else{
                presetquery = db.collection('pagepresets')
            }
            let presetpayload = {                
                query: presetquery,
                arrayname: 'RAStorePagePresets'
                }
                this.$store.dispatch('GetCollectionArray',presetpayload).then(function(result) {    
                    //console.log(vm.$store.state.RAPluginPackages)
                    })
        }
        
    },
    methods:{
        SingleNavItem(item){
            return this.Computedsitenavitems.filter(obj => {
                return obj.title === item
                })
        },
        RegressStep(){
            this.step--
            if(this.step !== 4){
                 if(this.PublicNavbarEditing){
                    this.TogglePublicNavbarEditing()
                }
            }
            else{
            }
        },
        AdvanceSetupStep(){
            if(this.step === this.AutoStep || typeof this.AutoStep !== 'number'){
                //now we need to actually capture info and shit...
                this.UpdateSiteInfo()
                this.step++
            }
            else{
                this.step++
            }
            if(this.step === 4){
                this.TogglePublicNavbarEditing()
            }
            else{
                if(this.PublicNavbarEditing){
                    this.TogglePublicNavbarEditing()
                }
            }
        },
        CancelProgressSheet(){
            this.Incomplete = false
             if(this.PublicNavbarEditing){
                    this.TogglePublicNavbarEditing()
                }
        },
        ActivateProgressSheet(){
            if(typeof this.AutoStep === 'number'){
                this.step = this.AutoStep
            }
            this.Incomplete = true
        },
        DownloadVCard(){
            let payload = this.ActiveFeaturedMember
            this.$store.dispatch('CreateVCard',payload).then(vcard => {
            //console.log(vcard)
            this.VCardLink = 'data:text/vcard;charset=UTF-8,'+vcard    
            })
            
        },
        DownloadQR(appurl,path,final,name){
      var QRAPI = "https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&data="
      var options = {
                      method: 'GET',
                      mode: 'cors'
                    }
      var RoutingUrl = path+final
      var hostingURL = appurl  
      var QRUrl = hostingURL+RoutingUrl
      console.log('QRUrl',QRUrl)
      var FetchURL = QRAPI+QRUrl
      fetch(FetchURL, options).then((resp) => resp.blob()
        .then(QRimage => {
        var QRLocalURL = URL.createObjectURL(QRimage)
            var element = document.createElement('a')
            element.setAttribute('href',QRLocalURL)
            element.setAttribute('download', name+' QRCode')
            element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
      )
    },
        AssignPublicNavbarIMG(){
           this.Site[this.IMGProp] = this.SelectedImage
           this.AddingProfilePhoto = true
           setTimeout(() => {
                this.AddingProfilePhoto = false
           }, 50);
           //console.log(this.Site)
            this.$store.commit('setIMGProp','')
        },
        ActivateGalleryDialog(type){
        // this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
        // this.$store.commit('setGalleryAssets',this.ActiveFeaturedMember.Assets)
        // this.$store.commit('setEditedTab',this.EditedTab)
        this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        this.$store.commit('setIMGProp',type)
        
        //GalleryLibraries
        //methods ? SelectGalleryAssets
      },
    TogglePublicNavbarEditing(){
        this.$emit('TogglePublicNavbarEditing')
    },
        UpdateNavigationalItems(){
            let array = ['PublicNavbarDark','PublicNavbarStyle','PublicNavbarText','PublicNavbarSelectedText','PrependedPublicNavbarActions','AppendedPublicNavbarActions','Public_NavBar_IMG',
            'PublicNavbarItemSelectBG','PublicNavbarItemHoverBG']
            let updobj = {}
            // Object.assign({},this.ActiveFeaturedMember)
            // delete updobj.Pages
            // delete updobj.Assets
            // delete updobj.PagePresets
            array.map(item => {
                let check = this.Site[item]
                if(typeof check !== 'undefined'){
                    updobj[item] = check
                }
            })
            db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).update(updobj).then(updateddoc => {
               
            })
        },  
        removeWhiteSpace(text) {
        return text.replace(/[\s\/]/g, '');
      },
        UpdateClearNavbarColor(page){
            db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).collection('Pages').doc(page.id).update({
                ClearNavbarColor: page.ClearNavbarColor
            })
        },
        UpdateSiteInfo(){
            if(!this.Site.KeyWords){
                this.Site.KeyWords = []
            }
            if(!this.Site.Full_Name && this.Site.id === this.userLoggedIn.id){
                this.Site.Full_Name = this.userLoggedIn.Full_Name
                this.Site.Name = this.userLoggedIn.Name
                this.Site.Surname = this.userLoggedIn.Surname
            }
            let updobj = {
                KeyWords: this.Site.KeyWords.map(kw => {
                    let kwobj = {}
                    if(!kw.id){
                        let user = {Full_Name: this.userLoggedIn.Full_Name,id: this.userLoggedIn.id}
                        let date = new Date()
                        kwobj.Name = kw
                        kwobj.Type = {
                            ID: 1000003,
                            Name: 'Featured Member'
                        },
                        kwobj.Created_By = user  
                        kwobj.Created_Byid = user.id
                        kwobj.Modified_By = user         
                        kwobj.Modified_Byid = user.id
                        kwobj.Created_On = date
                        kwobj.Modified_On = date
                        kwobj.Original_Recordid = this.$route.params.id
                    }
                    else{
                        kwobj = Object.assign({},kw)
                    }
                    return kwobj
                }),
            }
            this.AdditionalFields.map(field => {
                if(typeof this.ActiveFeaturedMember[field.Name] !== 'undefined'){
                    updobj[field.Name] = this.ActiveFeaturedMember[field.Name]
                }
            })
            if(typeof this.Site.Published !== 'undefined'){
                updobj.Published = this.Site.Published
            }
            if(this.Site.Full_Name){
                updobj.Full_Name = this.Site.Full_Name
                updobj.Name = this.Site.Name
                updobj.Surname = this.Site.Surname
            }
            if(this.Site.Mobile_Number){
                updobj.Mobile_Number = this.Site.Mobile_Number
            }
            if(this.Site.Email){
                updobj.Email = this.Site.Email
            }
            if(this.Site.DefaultPage){
                updobj.DefaultPage = this.Site.DefaultPage
            }
            if(this.Site.Overview){
                updobj.Overview = this.Site.Overview
            }
            if(this.Site.Profile_Photo){
                updobj.Profile_Photo = this.Site.Profile_Photo
            }
            let unregisteredkeywords = updobj.KeyWords.filter(kw => {
                return !kw.id
            })
            //console.log(unregisteredkeywords)
            if(unregisteredkeywords.length > 0){
                //kw types = 1000001 site page, 1000002 grou page, 1000003 featued mem
                unregisteredkeywords.map((kw,kwindex) => {
                     let path = db.collection('Websites').doc(this.$store.state.ActiveSuiteid).collection('sitekeywords')
                        let ref = path.doc()
                        let newdocid = ref.id
                    db.collection('Websites').doc(this.$store.state.ActiveSuiteid).collection('sitekeywords').doc(newdocid).set(kw).then(newkwdoc => {
                        let sitekwobj = updobj.KeyWords.find(obj => obj.Name === kw.Name)
                        sitekwobj.id = newdocid
                        if(kwindex-1+2 === unregisteredkeywords.length){
                            db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).update(updobj).then(upddoc => {
                                //this.CancelUpdateSiteInfo()
                            })
                        }
                    })
                })
            }
            else{
                db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).update(updobj).then(upddoc => {
                    //this.CancelUpdateSiteInfo()
                })
            }
            //console.log(updobj)
            //technically now I need to do this one better I must check registry or check keywords and if no "id" it must first be registered
            //db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).update(updobj)
        },
        UpdateMemberMenubar(PublicNavbarStyle){
            db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).update({
                PublicNavbarStyle: PublicNavbarStyle
            })
        },
        AddTabBelow(block){
            this.$store.commit('setdragging',block)
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','AddTabBelow')
        },
        ActivateTemplateDialog(primcat,index){
            //ComputedSitePages
            console.log('index',index,this.ComputedNavbarPages[index])
            let user = {Full_Name: this.userLoggedIn.Full_Name,id: this.userLoggedIn.id}
            let date = new Date()
            let systemid = process.env.VUE_APP_RA_SYSTEM_ID
            let systemurl = this.System.ClientAppURL
            let defobj = {
                Templateid: '',
                Systemid: systemid,
                ClientAppURL: systemurl,
                PublishStatus: 'Draft',
                Owner: user,          
                Ownerid: user.id,
                RouteName: this.$route.name,
                Created_By: user,          
                Created_Byid: user.id,
                Modified_By: user,          
                Modified_Byid: user.id,
                Created_On: date,
                Modified_On: date,
                // TemplateProps: {},
                TemplateObj: {},
                Primary_Category: {
                    ID: 1000001,
                    Name: 'Page'
                },
                Secondary_Category: {
                        ID: 1000004,
                    Name: 'Featured Member'
                }
            } 
            let payload = Object.assign({},defobj)
            if(primcat === 'Site'){
                payload.Primary_Category = {
                    ID: 1000002,
                    Name: 'Site'
                }
                payload.Templateid = this.$route.params.id
                //yes because slug is the page
                payload.TemplateProps = {
                    //Children: this.ComputedNavbarPages,
                    //ComputedSitePages but yeah gonna need simply template ids right?
                     //[this.SelectedNavbar.Prop]: this.NavListArray
                     //should cover for all I guess?
                     Navlist: this.NavListArray,
                     NavlistProp: this.SelectedNavbar.Prop
                }
                //actually we need EVERYTHING that can come with a template IF template is Type "Site"  being
                //same as updatenagivational9items
                let array = ['PublicNavbarDark','PublicNavbarStyle','PublicNavbarText','PublicNavbarSelectedText','PrependedPublicNavbarActions','AppendedPublicNavbarActions','Public_NavBar_IMG','PublicNavbarItemSelectBG','PublicNavbarItemHoverBG']
                array.map(prp => {
                    if(typeof this.Site[prp] !== 'undefined'){
                        payload.TemplateProps[prp] = this.Site[prp]
                    }
                })
                payload.Components = this.ComputedNavbarPages.map(page => {
                    let childtempobj = Object.assign({},defobj)
                    let childpage = this.ComputedSitePages.find(obj => obj.Name === page.Name)
                    if(childpage){
                        childtempobj.Templateid = childpage.id
                    }
                    else{
                        childtempobj.Templateid = page.Name.split(' ').join('_')
                    }
                    childtempobj.TemplateObj = page
                    childtempobj.Icon = page.PageIcon
                    childtempobj.Name = page.Name
                    return childtempobj
                })
                //?
            }
            else{
                Templateid = this.$route.params.slug
                //yes because id is the member id
                let temppage = this.ComputedNavbarPages[index]
                TemplateObj = {
                    Icon: temppage.PageIcon,
                    //how do we get entire page on here?
                    ...temppage
                }
            }
            this.$store.commit('SetSocialItemInteractMethodProp',payload) 
            this.$store.commit('SetSocialItemInteractMethod','ActivateMarketplaceTemplateDialog')
        },
        MoveItemMenuPos(index,direction,list){
            //if tab Tabdragstart and Tabdragfinish
            let newindex = index
            if(direction === 'Up'){
                newindex = newindex-1
            }
            else{
                newindex = newindex-1+2
            }
            if(list === 'PageTabs'){
                this.Tabdragstart(this.PageTabs[index],index)
                this.Tabdragfinish(newindex)
            }
            else{
              list.splice(newindex,0,list.splice(index,1)[0])  
            }
            

        },
        ToggleTransposedRowsandCols(bool){
            this.$store.commit('SetSocialItemInteractMethodProp',bool) 
            this.$store.commit('SetSocialItemInteractMethod','ToggleTransposedRowsandCols')
        },
        ConfirmDeletePage(page){
            confirm('This will remove this page, there is no undo, are you sure?') && this.ProcessDeletePage(page)
        },
        ProcessDeletePage(page){
            this.RemovePagefromNavlistArray(page)
            //yeah this remove menu thing not working so well bob
            db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).collection('Pages').doc(page.id).delete()
            //but actually let's make sure it's NOT on the menu so
        },
        AdvanceContentBlocktoPresetDial(){
            if(this.BulkContentPresetStep === 1){
                this.BulkContentPresetStep++
            }
            else{
                this.BulkContentPresetStep = 1
                this.SaveRAPreset()
            }
        },
        CancelRAPresetDialog(BulkAdding){
            this.RAPresetDialog = false
            if(BulkAdding){
                this.BulkContentPresetStep = 1
                if(this.AddingBlocks[this.BulkContenttoPresetIndex-1+2]){
                    this.BulkContenttoPresetIndex++
                    this.RAPresetTab = Object.assign({},this.AddingBlocks[this.BulkContenttoPresetIndex-1+2])
                    this.BulkContentPresetStep++
                }
                else{                    
                    this.BulkContentBlocktoPresetDialog = false
                    this.AddingBlocks = []
                    this.RAPresetTab = Object.assign({},this.DefaultRAPresetTab)
                }
            }
            else{
            this.RAPresetTab = Object.assign({},this.DefaultRAPresetTab)
            }
        },
        SaveRAPreset(){
            let newdocid = this.RAPresetTab.Preset_Name.split(' ').join('_')
            if(this.RAPresetTab.Database === 'RA Presets'){
            //honestly don't even want this to be an option...
            //  this.RADB.collection('pagepresets').doc(newdocid).set(this.RAPresetTab).then(newdoc => {
            //     this.CancelRAPresetDialog(this.BulkContentBlocktoPresetDialog)
            // })
            }
            else{
                //okay remember now please...this is NOT pagetemplates. in fact it got ZERO to do with Templates...it's personal user stored . 
              db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id).collection('storedpagepresets').doc(newdocid).set(this.RAPresetTab).then(newdoc => {
                this.CancelRAPresetDialog(this.BulkContentBlocktoPresetDialog)
            })  
            }
        },
        AddRAPresetDialog(tab){
            this.RAPresetTab = JSON.parse(JSON.stringify(tab))
            if(!this.RAPresetTab.Database){
                this.RAPresetTab.Database = 'Client'
            }
            this.RAPresetDialog = true
        },
        NavigatetoPage(page){
            //console.log('yay we navigate to page '+page.id)
           // this.$router.push(page.id)
             let path = '/FeaturedMemberEditor/'+this.$route.params.id+'/'+page.id.split(' ').join('_')
            if(this.$route.path !== path){
                this.$router.push(path)
            }
        },
        OnePropEmit(Method,Prop){
            this[Method](Prop)
            //console.log(Method,Prop)
        },
        FourPropsEmit(Method,Prop,SecondProp,ThirdProp,FourthProp){
            this[Method](Prop,SecondProp,ThirdProp,FourthProp)
            //console.log(Method,Prop,SecondProp,ThirdProp,FourthProp)
        },
        TwoPropsEmit(Method,Prop,SecondProp){
            this[Method](Prop,SecondProp)
            //console.log(Method,Prop,SecondProp)
        },
        PageItemStyle(page,parentpage){
            let style = ''
            if(!page.SubPage){
                if(this.SelectedPage.Name === page.Name){
                    style = 'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }
                else{
                    style = 'border: 1px solid #eee !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }
            }
            else{
                // padding-left: 30px !important;
                if(this.SelectedPage.Name === page.Name){
                    style = 'border: 1px solid #89bcd9 !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }
                else{
                    style = 'border: 1px solid #eee !important;border-radius: 6px;cursor: all-scroll !important;color: links !important;'
                }  
            }
            //console.log(style)
            return style
            
        },
        NavigatetoLibraryEditor(doclib){
            let path = '/DocumentationLibraryEditor/'+doclib.id+'/'+doclib.FirstPageName.split(' ').join('-')
            if(this.$route.path !== path){
                this.$router.push(path)
            }
        },
        AddDocumentationLibrary(PublishType){
             this.AssignSocialItemInteractMethod('ToggleNewDocLibDialog',PublishType)
        },
        PrepareActivateFullGallery(prop){
            this.$store.commit('setIMGProp','AppStylingIMG')
            this.AppStylingIMGProp = prop
            this.ActivateFullGallery()
        },
        AssignImageandCloseTab(){
            console.log('AssignImageandCloseTab')
            if(this.IsGroupView){
                this.ActiveGroup[this.AppStylingIMGProp] = this.SelectedImage
            }
            else{
                this.System[this.AppStylingIMGProp] = this.SelectedImage
            }
        },
        UpdateGroupStyling(){
      if(this.ActiveGroup.NavBar_IMG){
         db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavBar_IMG: this.ActiveGroup.NavBar_IMG
        })
      }     
      if(this.ActiveGroup.NavbarTextColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavbarTextColor: this.ActiveGroup.NavbarTextColor
        })
      }
      if(this.ActiveGroup.NavbarBGColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavbarBGColor: this.ActiveGroup.NavbarBGColor
        })
      }
      if(this.ActiveGroup.NavItemsBGColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavItemsBGColor: this.ActiveGroup.NavItemsBGColor
        })
      }
      if(this.ActiveGroup.NavItemsTextColor){
        db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).update({
          NavItemsTextColor: this.ActiveGroup.NavItemsTextColor
        })
      }
      
    },
        SetColorstoSystemColors(System){
            this.$emit('SetColorstoSystemColors',System)
        },
        PrepareAddressField(fieldname,obj){
        let field = this[fieldname]
        
        field.FieldBreakdown = []
        let StreetNumber = {Name: field.Name+'_Street_Number',DisplayName: 'Street Number', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: '', SampleText: '1'}
        let StreetName = {Name: field.Name+'_Street_Name',DisplayName: 'Street Name', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: '', SampleText: 'Long Street'}
        let Suburb = {Name: field.Name+'_Suburb',DisplayName: 'Suburb', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'SmallVille'}
        let City = {Name: field.Name+'_City',DisplayName: 'City', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'Big Town'}
        let PostalCode = {Name: field.Name+'_Postal_Code',DisplayName: 'Postal Code', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, SampleText: '1777'}
        let StateProvince = {Name: field.Name+'_State_Province',DisplayName: 'State Province', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'FarmState'}
        let CountryRegion = {Name: field.Name+'_Country_Region',DisplayName: 'Country Region', Primary: '', Secondary: '', Type: 'Child Common Field', IsSearch: true, IsFilter: true, SampleText: 'DisneyLand'}
        field.FieldBreakdown = []
        field.FieldBreakdown.push(StreetNumber)
        field.FieldBreakdown.push(StreetName)
        field.FieldBreakdown.push(Suburb)
        field.FieldBreakdown.push(City)
        field.FieldBreakdown.push(PostalCode)
        field.FieldBreakdown.push(StateProvince)
        field.FieldBreakdown.push(CountryRegion)
        field.Response = {
            [field.Name+'_Street_Number'] : obj[field.Name+'_Street_Number'],
            [field.Name+'_Street_Name'] : obj[field.Name+'_Street_Name'],
            [field.Name+'_Suburb'] : obj[field.Name+'_Suburb'],
            [field.Name+'_City'] : obj[field.Name+'_City'],
            [field.Name+'_Postal_Code'] : obj[field.Name+'_Postal_Code'],
            [field.Name+'_State_Province'] : obj[field.Name+'_State_Province'],
            [field.Name+'_Country_Region'] : obj[field.Name+'_Country_Region']
        }
        //console.log(obj,obj[field.Name+'_Street_Number'],field.Name+'_Street_Number',StreetNumber,field.Response)
      },
        
        CancelDrag(){
            this.$store.commit('setdragging','') 
        },
        blockdragstart(block) {									
        //console.log(block)	
        this.$store.commit('setdragging',block) 								
        },
        HideTabElements(i){
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','HideTabElements')
        },
        ShowTabElements(i){
            //console.log(i)
            this.$store.commit('SetSocialItemInteractMethodProp',i) 
            this.$store.commit('SetSocialItemInteractMethod','ShowTabElements')
        },
        Elmntdragstart(tab,tabindex,elmnt,elmntindex){		
            //console.log(tab,tabindex,elmnt,elmntindex)	
            this.$store.commit('setdraggingtab',tab) 
            this.$store.commit('setdraggingtabindex',tabindex)
            this.$store.commit('setdraggingelement',elmnt)
            this.$store.commit('setdraggingelementindex',elmntindex)								
        },									
        Elmntdragfinish(to){
            //to is now payload with tab,i,elmnt,elmntindex	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Elmntdragfinish')
        },
        Tabdragstart(row,rowindex){									
            this.$store.commit('setdraggingrow',row) 
            this.$store.commit('setdraggingrowindex',rowindex)				
        },									
        Tabdragfinish(to,ev){	
            // this.$store.commit('SetSocialItemInteractMethodProp',to) 
            // this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')								
            // this.PageTabs.splice(to, 0, this.PageTabs.splice(this.draggingrowindex, 1)[0]);	
            this.$store.commit('SetSocialItemInteractMethodProp',to)
            this.$store.commit('SetSocialItemInteractMethod','Tabdragfinish')						
        },	
        GetGalleryObjects(){									
            let routes = this.$router.getRoutes()									
            let GalleryPaths = routes.filter(option => {return option.meta && option.meta.photolibrary})									
            console.log('GalleryPaths',GalleryPaths)									
            GalleryPaths.map(path => {	
                let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                if(!check){		
                    let libraryobj = {									
                        name: path.meta.subcat,									
                        compname: path.meta.subcat.split(' ').join(''),									
                        Assets: [],								
                    }	
                    let libentity = this.SystemPhotoLibraries.find(obj => obj.id === path.meta.EntityID)	
                    if(libentity){
                        if(libentity.CustomTags){
                            libraryobj.CustomTags = libentity.CustomTags  
                            libraryobj.EntityCollectionRef = db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('PhotoLibraries').doc(libentity.id)	
                        }
                        libraryobj.TableCollectionRef = db.collection(libentity.id.split('_').join('').toLowerCase())
                        this.GalleryLibraries.push(libraryobj)	
                        this.GetGalleryItems(path)                                    
                    }
                }
                else{
                    this.GetGalleryItems(path) 
                }						
            })									
        },									
        GetGalleryItems(path){									
            db.collection(path.name).onSnapshot(res => {									
                        const changes = res.docChanges();									
                        changes.forEach(change => {									
                          if (change.type === 'added') {									
                              let returnobj = {									
                              ...change.doc.data(),									
                              id: change.doc.id									
                            }									
                            //console.log(typeof this.SystemAssets)									
                            // returnobj.Library = path.meta.subcat									
                            let check = this.GalleryLibraries.find(obj => obj.name === path.meta.subcat)									
                            check.Assets.push(returnobj)									
                            //console.log(this.GalleryLibraries)									
                            									
                          }									
                        })									
                      })									
        },	
        
        //['ShowTabElements','HideTabElements','OpenDialog','AdjustRowAmount','Elmntdragstart','Elmntdragfinish','NoPropsemit','blockdragstart']
        // /AssignSocialItemInteractMethod(item,SecondProp)

        CancelNavItemDrag(){
            this.NavItemIndex = -1
            this.NavParentIndex = -1
        },
        NavItemDragStart(index,parentindex){
            //console.log(index)
            this.NavItemIndex = index
            if(parentindex){
                this.NavParentIndex = parentindex
            }
        },		
        NavItemDragFinish(index){
            console.log(index)
            if(this.NavParentIndex === -1){
             this.NavListArray.splice(index,0, this.NavListArray.splice(this.NavItemIndex, 1)[0])   
            }
            else{
                //actualy have to check if parent is...uhm...parent?
                let parentpage = this.NavListArray[this.NavParentIndex]               
                let fromistring = this.NavItemIndex
                let fromindex = fromistring.split('.')[1]                
                let from = Number(fromindex)-1
                let toistring = index
                let toindex = toistring.split('.')[1]
                let parentindex = toistring.split('.')[0]
                if(this.NavParentIndex === Number(parentindex)){
                let to = Number(toindex)-1
                console.log(from,to)
                parentpage.Children.splice(to,0, parentpage.Children.splice(from, 1)[0]) 
                parentpage.Children.map((child,childindex) => {
                    let parentnext = childindex-1+2
                    let newindex = this.NavParentIndex+'.'+parentnext
                    child.MenuIndex = newindex
                })               
                this.RefreshTitleDialog()
                }
                else{
                    alert('Cannot move between parents')
                }
                
            }
            console.log(this.NavListArray)
        },
        UpdateContentEditableField(prop,value,AdditionalSaveMethod,FieldObject){
            FieldObject[prop] = value
            console.log(AdditionalSaveMethod)
            if(AdditionalSaveMethod){
                this[AdditionalSaveMethod]()
            }
        },
        DeactivateSEODialog(){
            this.SEOBasicsDialog = false
            this.SEOPage = Object.assign({},this.DefaultSEOPage)
        },
        UpdateSEOBasics(){
            let updatepath = ''
            if(this.$route.name === 'PageEditor'){
                updatepath = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('Pages').doc(this.SEOPage.id)
            }
            else if(this.IsGroupView){
                updatepath = db.collection('SocialNetworks').doc(this.$store.state.ActiveSuiteid).collection('groups').doc(this.GroupID).collection('pages').doc(this.SEOPage.id)
            }
            updatepath.update({
                Overview: this.SEOPage.Overview,
                KeyWords: this.SEOPage.KeyWords,
                SEO: this.SEOPage.SEO
            }).then(updatedpage => {
                this.DeactivateSEODialog()
            })
        },
        ActivateSEOBasicsDialog(page){
            this.SEOPage = {
                Overview: page.Overview,
                KeyWords: [],
                PageRoute: page.PageRoute,
                Name: page.Name,
                Icon: page.PageIcon,
                id: page.id,
                SEO: false,
            }
            if(page.KeyWords){
                this.SEOPage.KeyWords = page.KeyWords
            }
            if(page.SEO){
                this.SEOPage.SEO = page.SEO
            }
            this.SEOBasicsDialog = true
        },
        ChangePageProp(page,Prop){
        },
        UpdatePageProp(page,Prop){
            let updatepath = db.collection('SystemConfig').doc(this.$store.state.ActiveSuiteid).collection('featuredmembers').doc(this.$route.params.id)
            .collection('Pages').doc(page.id)
            updatepath.update({
                [Prop]: page[Prop]
            })
        },
        ActivatePageBGDialog(){
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.SystemAssets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('setIMGProp','PageBGAsset')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        ActivateFullGallery(){
            //console.log('ActivateFullGallery')
            this.$store.commit('setGalleryLibraries',this.GalleryLibraries)
            this.$store.commit('setGalleryAssets',this.ActiveFeaturedMember.Assets)
            this.$store.commit('setEditedTab','')
            this.$store.commit('SetSocialItemInteractMethod','ToggleGalleryDialog')
        },
        RemovePagefromNavlistArray(page){
            let item = this[this.NavlistHolder][this.SelectedNavbar.Prop].find(obj => obj.title === page.Name)
            if(item){
                item.OnMenu = false
                item.MenuIndex = 100000
                let index = this[this.NavlistHolder][this.SelectedNavbar.Prop].indexOf(item)
                this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(index,1)
            }
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
        },
        PushPageUpwards(page){
            //console.log(page)
            let parentindex = page.MenuIndex.split('.')[0]
            parentindex = Number(parentindex)
            console.log(page.MenuIndex,parentindex)
            //MOYO IMPORTANTE!!!! WHEN MANIPULATING WE SHOULD INF ACT MANIPULATE COMPUTEDNAVLIST, BECAUSE COMPUTEDNAVBARPAGES REFER TO IT
            //Here by example, we first used Navbarpages to obtain parent page. when you splice the children array it removes but immediatley pushes back in due to computednavlist obj still having it as a child
            let parentpage = this.ComputedNavList.find(obj => obj.id === page.Parentid)            
            let childindex = page.MenuIndex.split('.')[1]
            childindex = Number(childindex)-1
            //console.log(parentpage.Children.length)
            parentpage.Children.splice(childindex,1)
            // console.log(parentpage.Children.length)
            // console.log(parentpage,childindex)
            let pageobj = this.NavbarPages.find(obj => obj.id === page.id)
            pageobj.SubPage = false
            page.SubPage = false
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: parentindex-1+2,
            }   
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            if(parentpage.OnMenu){
                navpage.OnMenu = parentpage.OnMenu
            }
            this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(parentindex-1+2,0,navpage)
            
            this[this.NavlistHolder][this.SelectedNavbar.Prop].map((item,itemindex) => {
                item.MenuIndex = itemindex
                if(item.Children){
                    item.Children.map((child,childindex) => {
                    let parentnext = childindex-1+2
                    let newindex = item.MenuIndex+'.'+parentnext
                    child.MenuIndex = newindex
                })
                }
                
            })
            this.RefreshTitleDialog()
        },
        SortChildrenAlphabetically(page){
            let parentpage = this.NavListArray[page.MenuIndex]
            console.log(parentpage)
            parentpage.Children.sort((a, b) => {
                var key1 = a.title;
                var key2 = b.title;
                if (key1 < key2) {
                    return -1;
                } else if (key1 == key2) {
                    return 0;
                } else {
                    return 1;
                }
             }).map((child,childindex) => {
                    let parentnext = childindex-1+2
                    let newindex = parentpage.MenuIndex+'.'+parentnext
                    //console.log(newindex,typeof newindex,Number(newindex).toFixed(3))
                    child.MenuIndex = newindex
                })
                this.RefreshTitleDialog()
                //console.log(page)
        },
        PushtoPreviousNavItem(page){
            let fromaddpage = false
            let parentindex = 0
            if(this.NavParentIndex !== -1){
                fromaddpage = true
                parentindex = this.NavParentIndex
                this.NavParentIndex = -1
            }
            else{
                parentindex = page.MenuIndex-1
            }
            console.log(fromaddpage,parentindex)
            let parentpage = this[this.NavlistHolder][this.SelectedNavbar.Prop][parentindex]
            if(!parentpage.Children){
                parentpage.Children = []
            }
            let parentnext = parentpage.Children.length-1+2
            let newindex = parentindex+'.'+parentnext
           //console.log(newindex,typeof newindex,parentpage)
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: newindex,
                ParentIndex: parentindex,
                Parentid: parentpage.id
            }   
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            console.log(page,parentpage,navpage,newindex)     
            if(!fromaddpage){
              this[this.NavlistHolder][this.SelectedNavbar.Prop].splice(page.MenuIndex,1)  
            }            
            parentpage.Children.push(navpage)
            page.SubPage = true
           this.RefreshTitleDialog()
        },
        RefreshTitleDialog(){
            let title =this.SelectedMain.title
                this.SelectedMain.title = ''
                setTimeout(() => {
                    this.SelectedMain.title = title
                    console.log(this[this.NavlistHolder][this.SelectedNavbar.Prop])
                }, 10); 
        },
        PushPagetoNavlistArray(page){
            page.SubPage = false
            let navpage = {
                id: page.id,
                Path: page.PageRoute,
                title: page.Name,
                MenuIndex: this[this.NavlistHolder][this.SelectedNavbar.Prop].length
            }
            if(page.PageIcon){
                navpage.icon = page.PageIcon
            }
            this[this.NavlistHolder][this.SelectedNavbar.Prop].push(navpage)
            this.SelectedMainDialog = false
            setTimeout(() => {
                    this.SelectedMainDialog = true
            }, 10);
        },
        UpdateMenu(){
            if(this.NavListArray){
             this.NavlistRef.update({
                [this.SelectedNavbar.Prop]: this.NavListArray
            })
            let flatnavlist = this.NavListArray.map(item => {
                let arr = []
                if(item.Children){
                    arr = [item].concat(item.Children)
                }
                else{
                    arr = [item]
                }
                return arr
            }).flat()
            //console.log(flatnavlist)
            this.NavbarPages.map(page => {
                let item = flatnavlist.find(obj => obj.id === page.id)
                //console.log(page.id,item)
                if(!item){
                    page.SubPage = false
                    page.MenuIndex = ''
                    if(page.ParentIndex !== ''){
                        page.ParentIndex = ''
                        page.Parentid = ''
                    }
                }
                else{
                    page.MenuIndex = item.MenuIndex
                    this.UpdatePageProp(page,'MenuIndex')
                    if(typeof page.SubPage !== 'undefined'){
                    this.UpdatePageProp(page,'SubPage')  
                    }       
                    if(typeof item.ParentIndex !== 'undefined'){
                        page.ParentIndex = item.ParentIndex
                        this.UpdatePageProp(page,'ParentIndex')
                        page.Parentid = item.Parentid
                        this.UpdatePageProp(page,'Parentid')
                    }

                }
                
            }) 
            // this.NavListArray.map(item => {   
            //     let page =this.NavbarPages.find(obj => obj.id === item.id)
            //     if(typeof page.SubPage !== 'undefined'){                    
            //         this.UpdatePageProp(page,'SubPage')                       
            //     }  
            //     this.UpdatePageProp(page,'MenuIndex')
            //     // if(item.Children){
            //     //     //console.log(page)
            //     //         item.Children.map(child => {
            //     //             let childpage =this.NavbarPages.find(obj => obj.id === child.id)
            //     //             //console.log(childpage)
            //     //             childpage.SubPage = true
            //     //             childpage.MenuIndex = child.MenuIndex
            //     //             this.UpdatePageProp(childpage,'SubPage') 
            //     //             this.UpdatePageProp(childpage,'MenuIndex') 
            //     //         })
            //     //     }              
            // })
            }
            
        },
        PageClass(page){
            if(this.SelectedPage.Name === page.Name){
                if(this.$vuetify.theme.dark){
                   return 'background lighten-2 sitenavitem' 
                }                
            }
            else{
                if(this.$vuetify.theme.dark){
                return 'background sitenavitem'
                }
                else{
                 return 'sitenavitem'   
                }
            }
        },
        
        AddNewPage(navbar,SubPage,parentindex){
            //console.log(navbar,SubPage,parentindex)
          if(typeof parentindex !== 'undefined'){
              this.NavParentIndex = parentindex
              this.$store.commit('SetRandomInteractProp','New Page as SubPage')
              console.log(this.NavParentIndex)
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog','Public')
          }
          else{
              this.AssignSocialItemInteractMethod('ToggleNewPageDialog','Public')
          }
        },
        AssignSocialItemInteractMethod(item,SecondProp){
        //console.log('AssignSocialItemInteractMethod',item,SecondProp)
        this.$store.commit('SetSocialItemInteractMethodProp','') 
        this.$store.commit('SetSocialItemInteractMethod','')
        if(SecondProp){
            this.$store.commit('SetSocialItemInteractMethodProp',SecondProp) 
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        else if(item){
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        },
        AssignRenderedContentBlocks(blocks){
            //console.log('sure we assign blocks',blocks)
            //THIS BECOMES STORE COMMIT
            this.RenderedContentBlocks = blocks
        },
        PrepareSelectedMain(prop){
            let item = this.Computedsitenavitems.find(obj => obj.title === prop)
            //console.log(prop,this.Computedsitenavitems,item)
            if(item){
              this.ActivateSelectedMain(item)  
            }            
        },
        ActivateSelectedMain(main,frompredial){
            //console.log(main)
            if(main.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.SecondProp && main.SecondProp.PreDialog && !frompredial){
                this.SelectedMain = main
            }
            else if(main.Method){
                this.SelectedMainDialog = false
                this.SelectedMain = ''
             this.AssignSocialItemInteractMethod(main.Prop,main.SecondProp)   
            }
            else if(main.Route){
                this.$router.push('/'+main.Route)
            }
            else{
                this.SelectedMain = main
            }
        },
        NavigatetoWebFormEditor(entityid){
             if(entityid !== this.$route.params.id){
                if(this.IsGroupView){
                    this.$router.replace({name: 'GroupWebFormEditor', query: {GroupID: this.GroupID},params: {id: entityid}})  
                }
                else{
                    this.$router.push('/WebFormEditor/'+entityid)
                }
             }        
        },
        NavigatetoWebFormBuilder(){
            if(this.IsGroupView){
             this.$router.replace({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}})   
            }
            else{
                this.$router.push('/WebFormBuilder-New')
            }
            
            // let routeData = this.$router.resolve({name: 'GroupWebFormBuilder', query: {GroupID: this.GroupID}});
            // window.open(routeData.href, '_blank');
        },
        SelectOtherPage(page){
            this.EditOtherPage(page)
        },
        EditOtherPage(SelectedPage){
            let newpath = '/DocumentationLibraryEditor/'+this.$route.params.id+'/'+SelectedPage.id
            if(this.IsGroupView){
                this.$router.push(newpath)
            }
            else{
                this.$router.push(newpath)
            }
        },
        
        AddContentDialog(EditedTab){
            if(EditedTab.ContentDialogType){
                let contentbox = this.ContentBlocks.find(obj => obj.Name === EditedTab.ContentDialogType.Name)
                EditedTab.ContentDialogBox = Object.assign({},contentbox)
                EditedTab.ContentDialogBox.Elevation = 0
                EditedTab.ContentDialogBox.Tile = true
                EditedTab.ContentDialogBox.Flat = true
                EditedTab.ContentDialogBox.IsContentDialog = true
            }
        },
    }
}
</script>

<style>
.progressiconpath {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.progressiconpath .circle {
    -webkit-animation: dash .9s ease-in-out;
    animation: dash .9s ease-in-out;
  }
.progressiconpath .line {
    stroke-dashoffset: 1000;
    -webkit-animation: dash .9s .35s ease-in-out forwards;
    animation: dash .9s .35s ease-in-out forwards;
  }
.progressiconpath .check {
    stroke-dashoffset: -100;
    -webkit-animation: dash-check .9s .35s ease-in-out forwards;
    animation: dash-check .9s .35s ease-in-out forwards;
  }

.progresstooltip {
    font-size: 1em!important;
    text-align: center!important;
}
.progresstooltip .success {
    color: #73AF55;
  }
.progresstooltip .error {
    color: #D06079;
  }


@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

</style>



